export const LANGUAGE_CODES = {
  "ENGLISH": "EN",
  "SPANISH": "ES",
  "PORTUGUESE (BR)": "PT",
  "FRENCH": "FR",
  "ARABIC": "AR",
};

export const RTL_LANGUAGES = new Set(["AR"]);

const translations = {
  EN: {
    nav_portfolio: "Portfolio", nav_stats: "Stats", nav_leaderboard: "Leaderboard", nav_referrals: "Referrals", nav_account: "Account", nav_help: "Help center",
    header_docs: "DOCS", header_support: "SUPPORT", header_switch_theme: "SWITCH THEME", header_language: "Language", header_edit_name: "Edit name", header_save_change: "SAVE CHANGE",
    footer_online: "ONLINE", footer_docs: "Docs", footer_support: "Support", footer_terms: "Terms", footer_privacy: "Privacy",
    stats_title: "Stats",
    stats_subtitle: "Live activity across the PropFunding ecosystem.",
    stats_free_accounts: "FREE ACCOUNTS STARTED",
    stats_qualified: "QUALIFIED TRADERS",
    stats_activated: "ACTIVATED ACCOUNTS",
    stats_usdc_paid: "TOTAL USDC PAID",
    stats_tip_free: "Free 10,000 PRP accounts opened to date",
    stats_tip_qualified: "Traders who reached the 1% target and satisfied all other trading rules",
    stats_tip_activated: "Accounts activated after qualifying",
    stats_tip_usdc_paid: "USDC paid out to traders to date",
    stats_history_label: "HISTORY",
    stats_qual_title: "Qualification activity",
    stats_qual_desc: "Traders reaching +1% over time.",
    stats_fee_title: "Where your activation fee goes",
    stats_fee_onetime: "ONE-TIME ACTIVATION FEE",
    stats_fee_onetime_desc: "Paid only after you reach +1%",
    stats_fee_badge: "Free to qualify",
    stats_fee_pool: "Withdrawal pool",
    stats_fee_pool_desc: "Set aside before withdrawals begin",
    stats_fee_returned: "Returned to you",
    stats_fee_returned_desc: "Your +1% is paid in USDC at activation",
    stats_fee_platform: "Platform",
    stats_fee_platform_desc: "Verification, payments and support",
    stats_fee_note: "Account revenue is not treated as a single operating bucket. Capital is separated to support liquidity, exposure management and long-term sustainability.",
    stats_redemptions_label: "REDEMPTIONS",
    stats_redemptions_title: "USDC paid to traders",
    stats_redemptions_desc: "Qualification redemptions and standard withdrawals.",
    stats_outcomes_label: "ACCOUNT OUTCOMES",
    stats_breaches_title: "Breaches",
    stats_breaches_desc: "Accounts that reached a trading loss limit.",
    stats_rules_label: "PLATFORM RULES",
    stats_rule_max_loss: "MAXIMUM LOSS",
    stats_rule_max_loss_desc: "Static maximum loss from starting balance.",
    stats_rule_daily: "DAILY LOSS LIMIT",
    stats_rule_daily_desc: "Maximum daily equity loss.",
    stats_rule_withdraw: "WITHDRAWAL LIMIT",
    stats_rule_withdraw_desc: "Maximum per rolling 28 days.",
    stats_rule_rate: "REDEMPTION RATE",
    stats_rule_rate_desc: "Fixed on every eligible redemption.",
    stats_transparency_label: "TRANSPARENCY",
    stats_transparency_title: "Nothing hidden",
    stats_transparency_desc: "Everything you need to know is visible before you trade.",
    stats_target_title: "The target",
    stats_target_desc: "+1% to qualify.",
    stats_rate_title: "The rate",
    stats_rate_desc: "1 PRP = 0.50 USDC.",
    stats_limits_title: "The limits",
    stats_limits_desc: "20% static max loss, 5% daily loss limit.",
    stats_cta_title: "Built to fund winners",
    stats_year_filter: "Filter by year",
    stats_loading: "Loading stats…",
    stats_load_error: "We couldn't load the stats.",
    stats_no_data: "No data yet.",
    stats_no_payouts: "No payouts yet.",

    stats_section_overview: "PLATFORM OVERVIEW",






    stats_daily_dd_breach: "Daily DD breach", stats_max_dd_breach: "Max DD breach",





    lb_active_traders: "ACTIVE TRADERS",
    lb_qualified_traders: "QUALIFIED TRADERS",
    lb_total_prp: "TOTAL PRP",
    lb_total_usdc_paid: "TOTAL USDC PAID",
    lb_usdc_paid: "USDC PAID",
    lb_tip_active: "Traders with an open account this cycle",
    lb_tip_qualified: "Traders who reached the 1% target and satisfied all other trading rules",
    lb_tip_total_prp: "Combined PRP account equity across all active trader accounts.",
    lb_tip_usdc_paid: "USDC paid out to traders to date",
    lb_tip_prp_profit: "It's the total cumulative PRP they have made.",
    lb_no_results: "No matching results for “{query}”",
    lb_loading: "Loading the leaderboard…",
    lb_load_error: "We couldn't load the leaderboard.",
    lb_empty: "No traders on the board yet.",
    lb_you: "you",
    lb_cta_title: "Ready to join the",
    lb_cta_highlight: "leaderboard?",
    lb_cta_desc: "No upfront fee, no consistency rule, and a fixed USDC value on every eligible PRP you earn.",
    lb_cta_desc_mobile: "Start with a 10,000 PRP account for free and prove your edge.",
    lb_cta_btn: "START FREE",
    share_text_line2: "Start trading for free with Propfunding.com",
    lb_title: "Leaderboard", lb_live: "LIVE", lb_live_update: "Updates every 5 minutes", lb_your_position: "YOUR POSITION", lb_share: "SHARE", lb_traders: "Traders", lb_search: "Search traders",
    lb_rank: "RANK", lb_name: "NAME", lb_prop_profit: "PRP PROFIT", lb_status: "STATUS", lb_usdc_payouts: "USDC PAYOUTS", lb_daily_dd: "DAILY DD", lb_max_dd: "MAX DD",
    lb_status_active: "ACTIVE", lb_status_critical: "CRITICAL", lb_status_breached: "BREACHED",
    lb_pool_balance: "POOL BALANCE", lb_funded_traders: "FUNDED TRADERS", lb_total_profit: "TOTAL PROFIT IN $PROP", lb_total_payouts: "TOTAL USDC PAYOUTS",
    lb_detail_week: "$8,400 this week", lb_detail_month: "-12 this month", lb_detail_across: "Across all funded accounts", lb_detail_5k_cycle: "$5,000 last cycle",
    ref_title: "Referrals", ref_copy: "Earn $25 for every trader you refer who activates.",
    ref_enter_code: "ENTER CODE", ref_share_link: "SHARE LINK", ref_withdraw: "WITHDRAW REWARD",
    ref_traders_referred: "TRADERS REFERRED", ref_rewards_earned: "REWARDS EARNED", ref_withdrawable: "WITHDRAWABLE REWARD", ref_min_required: "$125 min required",
    ref_history: "Referral history", ref_payout_date: "PAYOUT DATE", ref_status: "STATUS", ref_tab_all: "All", ref_tab_claimed: "Claimed", ref_status_trial: "Trial", ref_status_activated: "Activated", ref_status_claimed: "Claimed", ref_no_claimed: "No claimed rewards yet.", ref_no_referrals: "No referrals yet. Share your link to start earning.", ref_loading: "Loading your referrals…", ref_load_error: "We couldn't load your referrals.", ref_retry: "TRY AGAIN", ref_using_code: "You're using the code: {code}", ref_email: "EMAIL", ref_date_joined: "DATE JOINED", ref_fee_paid: "FEE PAID", ref_your_reward: "YOUR REWARD",
    ref_modal_share_title: "Share your referral link",
    ref_copy_btn: "COPY", ref_copied_btn: "COPIED",
    ref_modal_code_title: "Enter referral code",
    ref_code_placeholder: "Paste referral code or link",
    ref_stepper_request: "REQUEST", ref_stepper_review: "REVIEW", ref_stepper_wallet: "WALLET",
    ref_withdraw_title: "Withdraw reward",
    ref_withdrawable_label: "WITHDRAWABLE",
    ref_amount_label: "Amount to withdraw",
    ref_max_prefix: "MAX:",
    ref_min_text: "Minimum $125 required",
    ref_wallet_label: "USDC ERC20 wallet address",
    ref_continue_btn: "CONTINUE",
    ref_review_title: "Review request",
    ref_erc20_label: "WALLET ADDRESS",
    ref_amount_field: "AMOUNT",
    ref_currency_label: "CURRENCY",
    ref_processing_label: "PROCESSING",
    ref_processing_time: "24H (EXCLUDING WEEKENDS)",
    ref_confirm_btn: "CONFIRM WITHDRAWAL",
    ref_back_btn: "BACK",
    ref_success_title: "Withdrawal submitted",
    ref_success_subtitle: "Your USDC is on its way. It usually arrives within 24 hours.",
    ref_reference_label: "REFERENCE",
    ref_email_sent: "We'll email you as soon as it's been sent",
    port_title: "Portfolio", port_waiting_account: "We're out of trading accounts right now. You're in the queue: we'll assign you one automatically and email you as soon as one is free, even if you close this page.", port_overview: "OVERVIEW", port_balance: "BALANCE", port_profit_loss: "PROFIT/LOSS", port_drawdown: "DRAWDOWN", port_rank: "RANK", port_share: "SHARE",
    port_trading_obj: "TRADING OBJECTIVES", port_in_range: "IN RANGE",
    port_max_drawdown: "MAX DRAWDOWN", port_of_initial: "of initial balance",
    port_daily_loss: "DAILY LOSS LIMIT", port_of_starting: "of starting day's balance",
    port_monthly_profit: "MAX MONTHLY PROFIT",
    port_withdrawal_hist: "WITHDRAWAL HISTORY", port_date: "DATE", port_payout_amount: "PAYOUT AMOUNT", port_status: "STATUS", port_tx_id: "TRANSACTION ID", port_completed: "COMPLETED", port_view_all: "View all withdrawals",
    port_account_details: "ACCOUNT DETAILS", port_login: "LOGIN", port_master_pw: "MASTER PASSWORD", port_investor_pw: "INVESTOR PASSWORD", port_mt5_server: "MT5 SERVER", port_next_payout: "NEXT PAYOUT ELIGIBILITY", port_request_payout: "REQUEST PAYOUT",
    port_prop_value: "PROP VALUE", port_current_value: "CURRENT VALUE", port_usdc_per_prop: "USDC per $PROP", port_30d_change: "30D CHANGE",
    port_help_center: "HELP CENTER", port_docs: "DOCS", port_discord: "DISCORD",
    port_show_pw: "Show password", port_hide_pw: "Hide password",
    port_activate_title: "Activate your 10,000 prop account",
    port_one_time_fee: "One-time fee",
    port_profit_share: "100% profit share",
    port_about_title: "About PropFunding",
    port_no_consistency: "No consistency rules",
    port_no_min_days: "1:10 leverage available",
    port_biweekly: "Biweekly withdrawals",
    port_zero_comms: "$0 comms and raw spreads",
    port_forex_available: "Trade forex majors, minors and gold",
    port_platform_stats: "PLATFORM STATS",
    port_total_funded_stat: "TOTAL FUNDED TRADERS",
    port_pool_balance_stat: "POOL BALANCE",
    port_total_payouts_stat: "TOTAL USDC PAYOUTS",
    port_prop_value_stat_label: "$PROP VALUE",
    port_stat_week: "+23 this week",
    port_stat_backed: "Backed by real capital",
    port_stat_this_week: "This week",
    port_stat_7d: "+2.41% (7D)",
    port_real_payouts_title: "REAL TRADERS & REAL PAYOUTS",
    port_payout_modal_title: "Request payout",
    port_available_withdraw: "AVAILABLE TO WITHDRAW",
    port_prop_amount_label: "Amount to withdraw in $PROP",
    port_prop_min_error: "Minimum of {min} required",
    port_prop_max_error: "Exceeds available balance",
    port_prop_min_placeholder: "Min. {min}",
    port_payout_min_tooltip: "Minimum withdrawal amount: {min} PRP (2% of your account size).",
    port_prop_min_note: "2% minimum withdrawal required",
    port_you_receive: "YOU RECEIVE",
    port_paste_address: "Paste address",
    port_payout_request_label: "PAYOUT REQUEST",
    port_payout_rate_label: "RATE",
    port_usdc_redeemed_label: "USDC REDEEMED",
    port_processing_fee_label: "PROCESSING FEE",
    port_net_payout_label: "NET PAYOUT",
    port_confirm_payout_btn: "CONFIRM PAYOUT",
    port_payout_submitted_title: "Payout request submitted",
    port_payout_submitted_subtitle: "Our team will review your request. Updates usually provided within 24 hours.",
    footer_cta_title: "Start trading the", footer_cta_highlight: "new model",
    footer_cta_desc: "Join a system where performance, not the platform, determines outcomes.",
    footer_cta_btn: "GET FUNDED",
    share_modal_title: "Share leaderboard position",
    share_position_label: "Leaderboard\nposition",
    share_prop_profit: "PRP PROFIT", share_usdc_payouts: "USDC PAYOUTS", share_referral_code: "REFERRAL CODE",
    share_default_text: "I'm #{rank} on the PropFunding Leaderboard 🏆",
    share_field_referral: "Referral code", share_field_text: "Customize your text",
    share_overlay: "Overlay", share_overlay_none: "No overlay", share_overlay_bull: "Bull overlay", share_overlay_bear: "Bear overlay",
    share_save: "SAVE IMAGE", share_copy_link: "COPY LINK", share_on: "SHARE ON",
    share_saving: "SAVING…", share_loading: "Loading image", share_discord_copied: "Post copied. Paste it into Discord.", share_failed: "That didn't work. Please try again.",
    help_title: "Help center",
    help_subtitle: "Get help with your account and track support requests.",
    help_report_issue: "Report issue", help_report_issue_title: "Report issue",
    help_search_placeholder: "Search help articles",
    help_support_tickets: "Support tickets", help_tab_open: "Open", help_tab_resolved: "Resolved",
    help_issue: "Issue", help_category: "Category", help_submitted: "Submitted", help_status: "Status", help_action: "Action",
    help_status_in_progress: "In progress", help_status_resolved: "Resolved",
    help_see_details: "See details", help_manage: "Manage", help_no_tickets: "No tickets here.",
    help_faq: "FAQ", help_articles: "articles", help_popular_articles: "Popular articles",
    help_no_results: "No articles match your search.",
    help_ticket_details: "Ticket details", help_ticket_id: "Ticket ID", help_description: "Description", help_attachment: "Attachment",
    help_original_message: "Original message", help_additional_detail: "Additional detail",
    help_original_attachment: "Original attachment", help_additional_attachment: "Additional attachment",
    help_need_more_info: "Need to add information?", help_add_details_placeholder: "Add additional details...",
    help_upload_screenshot: "Upload screenshot", help_add_update: "Add update",
    help_status_sent: "Sent", help_select_category: "Select category",
    help_issue_description: "Issue description", help_issue_description_hint: "Please describe the issue in detail.",
    help_describe_placeholder: "Describe the issue you're facing...",
    help_attachment_optional: "Attachment (optional)", help_attachment_hint: "Upload a screenshot to help us understand the issue faster.",
    help_upload_or_drag: "Upload or drag file", help_cancel: "Cancel", help_submit_issue: "Submit issue",
    help_issue_reported: "Issue reported",
    help_issue_reported_note: "Your issue has been successfully reported. Keep an eye on the help center section for updates.",
    help_report_another: "Report another", help_done: "Done",
    help_report_category_issue: "Report {category} issue", help_articles_title: "Articles",
    help_team_reply: "Support team reply", help_loading: "Loading…", help_sending: "Sending…", help_tickets_error: "We couldn't load your tickets.", help_try_again: "Try again",
    checkout_title: "Purchase funded account",
    checkout_payment_method: "Payment method",
    checkout_card: "Credit/Debit card", checkout_card_soon: "Credit/Debit card (Coming Soon)", checkout_crypto: "Crypto (USDC/USDT)",
    checkout_discount: "Discount code", checkout_apply: "APPLY",
    checkout_summary: "Summary", checkout_account: "$10K Prop Account",
    checkout_discount_line: "Discount", checkout_total: "TOTAL",
 checkout_card_number: "Card number", checkout_expiry: "Expiry", checkout_cvv: "CVV", checkout_complete: "COMPLETE", checkout_billing: "Billing details", checkout_card_whop_text: "You'll enter your card details securely on the next step.", checkout_crypto_whop_text: "You'll be redirected to pay in USDC or USDT. Choose your network on the payment page and send only on that network.", checkout_confirming: "Confirming your payment…", checkout_processing: "Your payment is being processed. Your account will be activated as soon as it's confirmed.", checkout_back_portfolio: "BACK TO PORTFOLIO",
    cs_title: "Payment status", cs_loading: "Loading your payment…", cs_not_found: "We couldn't load this payment.", cs_awaiting: "Awaiting payment", cs_awaiting_desc: "Finish paying on the payment page. This page updates automatically.", cs_confirming: "Confirming", cs_confirming_desc: "Your payment is on the blockchain. We're waiting for it to be confirmed.", cs_partially_paid: "Partially paid", cs_partially_paid_desc: "We've received part of your payment. Send the remaining amount from the payment page.", cs_paid: "Paid", cs_paid_activation: "Payment received. Your account is activated.", cs_expired: "Expired", cs_expired_desc: "This payment request expired. If you already sent funds, contact support. Otherwise, start a new checkout.", cs_needs_review: "Under review", cs_needs_review_desc: "We've received your payment and our team is reviewing it. We'll be in touch shortly.", cs_amount_due: "Amount due", cs_paid_so_far: "Paid so far", cs_open_widget: "OPEN PAYMENT PAGE", cs_network_warning: "Send only USDC or USDT, and only on the network you chose on the payment page. Deposits sent on any other network will be lost.",
    checkout_funded_received: "Payment received. We're setting up your funded account and it will appear in your portfolio once it's ready.",


    port_tooltip_withdraw: "Maximum eligible withdrawal amount based on your MT5 account's net profit, net of applicable processing fees",
    port_tooltip_max_drawdown: "The static maximum loss based on your starting balance. If your equity reaches this level, the account is automatically disabled",
    port_tooltip_daily_loss: "Maximum equity loss allowed within a single trading day. The daily loss limit includes both open and closed positions",
    port_tooltip_monthly_profit: "The maximum profit you can withdraw within a calendar month. Resets on the 1st of each month",
    port_tooltip_balance: "Your total settled account balance in PRP after closed trades",
    port_tooltip_profit_loss: "Your realized profit or loss from completed trades",
    port_tooltip_drawdown: "Your current drawdown based on active and closed losing positions",
    port_tooltip_rank: "Your ranking among active PropFunding traders",
    port_tooltip_prop_value: "Eligible PRP profits convert at this fixed rate when withdrawn",
    port_free_title: "Free entry. One target.",
    port_free_desc: "Reach +1% on your 10,000 PRP account to qualify for activation.",
    port_start_trading: "START TRADING",
    port_getting_ready: "Getting your account ready...",
    port_free_accounts_stat: "FREE ACCOUNTS STARTED",
    port_qualified_stat: "QUALIFIED TRADERS",
    port_activated_stat: "ACTIVATED ACCOUNTS",
    port_total_paid_stat: "TOTAL USDC PAID",
    port_tooltip_free_accounts: "Total number of free 10,000 PRP accounts started on PropFunding",
    port_tooltip_qualified: "Traders who reached the +1% qualifying target",
    port_tooltip_activated: "Qualified accounts that paid the activation fee and completed KYC",
    port_tooltip_total_paid: "Total USDC paid out to PropFunding traders",
    port_inactivity: "INACTIVITY",
    port_tooltip_inactivity: "You need to trade at least once every 14 days or your account gets disabled",
    port_qualifying_target: "QUALIFYING TARGET",
    port_tooltip_qualifying: "Grow your 10,000 PRP account by 1% to qualify for activation",
    port_min_trading_days: "MINIMUM TRADING DAYS",
    port_tooltip_min_days: "Your account needs at least 3 trading days to qualify",
    port_achieved: "achieved",
    port_reached: "reached",
    port_days: "days",
    port_process: "THE PROCESS",
    port_how_it: "How it",
    port_works: "works",
    port_step1_title: "Start free",
    port_step1_desc: "Start trading your 10,000 PRP account with no upfront fee.",
    port_step2_title: "Reach +1%",
    port_step2_desc: "Grow your account by 1% to qualify. Accounts need at least 3 trading days to qualify.",
    port_step3_title: "Activate and verify",
    port_step3_desc: "Pay the activation fee within 48 hours and complete your KYC.",
    port_step4_title: "Redeem in USDC",
    port_step4_desc: "Withdraw your +1% qualification profit in USDC at activation. Your account resets, and standard withdrawals begin after 14 days.",
    port_mt5_account_details: "MT5 ACCOUNT DETAILS",
    port_usdc_per_prp: "USDC per PRP",
    port_hit_target: "You hit 1%.",
    port_time_to_activate: "Time to activate.",
    port_activate_desc: "Activate within 48 hours to unlock your funded account and withdraw your 1% qualification profit.",
    port_activate_soon: "Activate soon –",
    port_time_running_out: "time's running out",
    port_activate_urgent_desc: "You are at risk of losing your funded account. Pay the activation fee within 24 hours to prevent it.",
    port_window_title: "Activation window",
    port_window_expired: "expired",
    port_window_expired_desc: "Your 48-hour activation window has expired. This qualification can no longer be activated.",
    port_qualification_result: "QUALIFICATION RESULT",
    port_qualification_reached: "+1% reached",
    port_qualification_redemption: "QUALIFICATION REDEMPTION",
    port_expired_value: "Expired",
    port_activation_status: "ACTIVATION STATUS",
    port_expired_status: "EXPIRED",
    port_expired_on: "Expired {date} at {time}",
    port_start_next_attempt: "START NEXT FREE ATTEMPT",
    port_activation_fee: "ACTIVATION FEE",
    port_redeem_after_activation: "AVAILABLE REDEEM AFTER ACTIVATION",
    port_redeem_after_activation_short: "REDEEM AFTER ACTIVATION",
    port_time_left: "TIME LEFT TO ACTIVATE",
    port_hours: "hours",
    port_minutes: "minutes",
    port_seconds: "seconds",
    port_activate_short: "ACTIVATE",
    checkout_claim_title: "Pay to claim your funded account",
    checkout_card_with_fee: "Credit/Debit card (2.9% processing fee)",
    checkout_card_with_fee_short: "Credit/Debit card (2.9% fee)",
    checkout_activation_account: "$10K Prop Account",
    checkout_card_fee: "Card Processing Fee",
    checkout_crypto_plain: "Crypto",
    port_next_steps: "NEXT STEPS",
    port_pending: "PENDING",
    port_next_verify_title: "Verify your identity",
    port_next_verify_desc: "Quick KYC check to unlock payouts.",
    port_next_withdraw_title: "Withdraw your 1%",
    port_next_withdraw_desc: "Your reward for hitting the qualifying target.",
    port_next_trade_title: "Keep trading",
    port_next_trade_desc: "Chase the next milestone in the market.",
    port_kyc_title: "KYC VERIFICATION",
    port_kyc_required: "REQUIRED DOCUMENTS",
    port_kyc_doc_id: "Proof of ID (Passport, Driver's license, Government-issued ID).",
    port_kyc_doc_address: "Proof of address (Utility bill, Phone bill, Bank statement).",
    port_kyc_start: "START ID VERIFICATION",
    port_kyc_error: "VERIFICATION ERROR",
    port_kyc_error_desc: "We were unable to verify your identity.",
    port_kyc_try_again: "TRY AGAIN",
    port_kyc_contact_support: "Contact support",
    port_kyc_pending: "UNDER REVIEW",
    port_kyc_pending_desc: "We're reviewing your documents. This usually takes a few minutes – we'll update this card when it's done.",
    port_kyc_rejected_desc: "We couldn't verify your identity and this check can't be retried. Please contact support.",
    port_kyc_loading: "Starting verification...",
    port_withdraw_profit: "WITHDRAW PROFIT",
    port_to_withdraw: "TO WITHDRAW",
    port_tooltip_to_withdraw: "Your +1% qualification profit, redeemable in USDC",
    port_max_withdraw_note: "1% maximum withdrawal allowed",
    port_rule_title_max_drawdown: "Max drawdown",
    port_rule_title_daily_loss: "Daily loss",
    port_rule_title_inactivity: "Inactivity rule",
    port_rule_name_max_drawdown: "maximum drawdown",
    port_rule_name_daily_loss: "daily loss limit",
    port_rule_name_inactivity: "inactivity rule",
    port_and: "and",
    port_breach_desc_prefix: "Your account exceeded the",
    port_breach_desc_inactivity: "Your account has breached the inactivity rule.",
    port_breach_retry_left: "You have one more free retry left.",
    port_free_retry: "FREE RETRY",
    port_prp_value: "PRP VALUE",
    port_breached: "breached",
    port_exhausted_title: "Your free attempts are complete",
    port_exhausted_desc: "You've exhausted your free retries.",
    port_exhausted_offer: "You can still activate a funded account instantly for",
    port_promo_prefix: "Use code",
    port_promo_suffix: "to get 10% off.",
    port_offer_title: "🎉 FIRST ACTIVATION OFFER",
    port_offer_desc: "Use {code} at checkout to get 10% off your first activation.",
    port_offer_copy: "COPY CODE",
    port_offer_copied: "COPIED",
    port_offer_remaining: "{left} of {total} users remaining",
    port_get_funded_for: "GET FUNDED FOR",
    port_get_funded: "GET FUNDED",
    port_cycle_ended_title: "Trading cycle ended",
    port_cycle_ended_desc: "Your account exceeded the maximum drawdown & daily loss limits.",
    port_promo_new_account: "to get 10% off your new account.",
    port_get_funded_again: "GET FUNDED AGAIN",
    port_previous_cycle: "PREVIOUS CYCLE",
    port_drawdown_reached: "Drawdown reached",
    port_daily_loss_reached: "Daily loss reached",
    port_final_equity: "Final equity",
    port_what_we_offer: "WHAT WE OFFER",
    port_offer_free_title: "Start free",
    port_offer_free_desc: "Pay only after you reach +1%.",
    port_offer_loss_title: "20% static max loss",
    port_offer_loss_desc: "More room to trade.",
    port_offer_share_title: "100% profit share",
    port_offer_share_desc: "1 PRP = 0.50 USDC.",
    port_previous_payouts: "PREVIOUS PAYOUTS",
    port_view_all_payouts: "View all payouts",
    port_help_intro: "Our team is here if you need anything.",
    port_redemption_note: "From {prp} PRP at a {rate} USDC redemption rate",
    port_erc20_label: "USDC ERC20 ADDRESS",
    port_payout_review_note: "Please allow 24 hours for review. Once approved, your new MT5 account will be synced.",
    acc_full_name: "Full name",
    acc_email: "Email",
    acc_save: "SAVE",
    acc_saving: "SAVING…",
    acc_saved: "Saved.",
    port_mt5_download: "MT5 download",
    menu_dark_mode: "Dark mode",
    menu_join_discord: "JOIN DISCORD COMMUNITY",
    menu_logout: "LOG OUT",
  },

  ES: {
    nav_portfolio: "Cartera", nav_stats: "Estadísticas", nav_leaderboard: "Clasificación", nav_referrals: "Referidos", nav_account: "Cuenta", nav_help: "Centro de ayuda",
    header_docs: "DOCUMENTOS", header_support: "SOPORTE", header_switch_theme: "CAMBIAR TEMA", header_language: "Idioma", header_edit_name: "Editar nombre", header_save_change: "GUARDAR CAMBIO",
    footer_online: "EN LÍNEA", footer_docs: "Documentos", footer_support: "Soporte", footer_terms: "Términos", footer_privacy: "Privacidad",
    stats_title: "Estadísticas",
    stats_subtitle: "Actividad en vivo en el ecosistema PropFunding.",
    stats_free_accounts: "CUENTAS GRATIS INICIADAS",
    stats_qualified: "TRADERS CALIFICADOS",
    stats_activated: "CUENTAS ACTIVADAS",
    stats_usdc_paid: "TOTAL USDC PAGADO",
    stats_tip_free: "Cuentas gratuitas de 10,000 PRP abiertas hasta la fecha",
    stats_tip_qualified: "Traders que alcanzaron el objetivo del 1% y cumplieron todas las demás reglas de trading",
    stats_tip_activated: "Cuentas activadas tras calificar",
    stats_tip_usdc_paid: "USDC pagado a traders hasta la fecha",
    stats_history_label: "HISTORIAL",
    stats_qual_title: "Actividad de calificación",
    stats_qual_desc: "Traders que alcanzan +1% a lo largo del tiempo.",
    stats_fee_title: "A dónde va tu tarifa de activación",
    stats_fee_onetime: "TARIFA DE ACTIVACIÓN ÚNICA",
    stats_fee_onetime_desc: "Se paga solo después de alcanzar +1%",
    stats_fee_badge: "Gratis para calificar",
    stats_fee_pool: "Fondo de retiros",
    stats_fee_pool_desc: "Reservado antes de que comiencen los retiros",
    stats_fee_returned: "Se te devuelve",
    stats_fee_returned_desc: "Tu +1% se paga en USDC al activar",
    stats_fee_platform: "Plataforma",
    stats_fee_platform_desc: "Verificación, pagos y soporte",
    stats_fee_note: "Los ingresos de las cuentas no se tratan como un único fondo operativo. El capital se separa para respaldar la liquidez, la gestión de la exposición y la sostenibilidad a largo plazo.",
    stats_redemptions_label: "CANJES",
    stats_redemptions_title: "USDC pagado a traders",
    stats_redemptions_desc: "Canjes por calificación y retiros estándar.",
    stats_outcomes_label: "RESULTADOS DE CUENTAS",
    stats_breaches_title: "Incumplimientos",
    stats_breaches_desc: "Cuentas que alcanzaron un límite de pérdida.",
    stats_rules_label: "REGLAS DE LA PLATAFORMA",
    stats_rule_max_loss: "PÉRDIDA MÁXIMA",
    stats_rule_max_loss_desc: "Pérdida máxima estática desde el saldo inicial.",
    stats_rule_daily: "LÍMITE DE PÉRDIDA DIARIA",
    stats_rule_daily_desc: "Pérdida máxima diaria del capital.",
    stats_rule_withdraw: "LÍMITE DE RETIRO",
    stats_rule_withdraw_desc: "Máximo por cada 28 días móviles.",
    stats_rule_rate: "TASA DE CANJE",
    stats_rule_rate_desc: "Fija en cada canje elegible.",
    stats_transparency_label: "TRANSPARENCIA",
    stats_transparency_title: "Nada oculto",
    stats_transparency_desc: "Todo lo que necesitas saber está visible antes de operar.",
    stats_target_title: "El objetivo",
    stats_target_desc: "+1% para calificar.",
    stats_rate_title: "La tasa",
    stats_rate_desc: "1 PRP = 0.50 USDC.",
    stats_limits_title: "Los límites",
    stats_limits_desc: "20% de pérdida máxima estática, 5% de pérdida diaria.",
    stats_cta_title: "Hecho para financiar a los ganadores",
    stats_year_filter: "Filtrar por año",
    stats_loading: "Cargando estadísticas…",
    stats_load_error: "No pudimos cargar las estadísticas.",
    stats_no_data: "Aún no hay datos.",
    stats_no_payouts: "Aún no hay pagos.",

    stats_section_overview: "RESUMEN DE LA PLATAFORMA",






    stats_daily_dd_breach: "Infracción DD diaria", stats_max_dd_breach: "Infracción DD máxima",





    lb_active_traders: "TRADERS ACTIVOS",
    lb_qualified_traders: "TRADERS CALIFICADOS",
    lb_total_prp: "PRP TOTAL",
    lb_total_usdc_paid: "TOTAL USDC PAGADO",
    lb_usdc_paid: "USDC PAGADO",
    lb_tip_active: "Traders con una cuenta abierta este ciclo",
    lb_tip_qualified: "Traders que alcanzaron el objetivo del 1% y cumplieron todas las demás reglas de trading",
    lb_tip_total_prp: "Equity combinado de las cuentas PRP de todos los traders activos.",
    lb_tip_usdc_paid: "USDC pagado a traders hasta la fecha",
    lb_tip_prp_profit: "Es el total acumulado de PRP que han ganado.",
    lb_no_results: "No hay resultados para “{query}”",
    lb_loading: "Cargando la clasificación…",
    lb_load_error: "No pudimos cargar la clasificación.",
    lb_empty: "Aún no hay traders en la clasificación.",
    lb_you: "tú",
    lb_cta_title: "¿Listo para unirte a la",
    lb_cta_highlight: "clasificación?",
    lb_cta_desc: "Sin tarifa inicial, sin regla de consistencia y un valor fijo en USDC por cada PRP elegible que ganes.",
    lb_cta_desc_mobile: "Empieza gratis con una cuenta de 10,000 PRP y demuestra tu ventaja.",
    lb_cta_btn: "EMPEZAR GRATIS",
    share_text_line2: "Empieza a operar gratis con Propfunding.com",
    lb_title: "Clasificación", lb_live: "EN VIVO", lb_live_update: "Se actualiza cada 5 minutos", lb_your_position: "TU POSICIÓN", lb_share: "COMPARTIR", lb_traders: "Traders", lb_search: "Buscar traders",
    lb_rank: "RANGO", lb_name: "NOMBRE", lb_prop_profit: "GANANCIA PRP", lb_status: "ESTADO", lb_usdc_payouts: "PAGOS USDC", lb_daily_dd: "DD DIARIO", lb_max_dd: "DD MÁXIMO",
    lb_status_active: "ACTIVO", lb_status_critical: "CRÍTICO", lb_status_breached: "INFRINGIDO",
    lb_pool_balance: "BALANCE DEL POOL", lb_funded_traders: "TRADERS FINANCIADOS", lb_total_profit: "GANANCIA TOTAL EN $PROP", lb_total_payouts: "TOTAL PAGOS USDC",
    lb_detail_week: "$8,400 esta semana", lb_detail_month: "-12 este mes", lb_detail_across: "En todas las cuentas financiadas", lb_detail_5k_cycle: "$5,000 último ciclo",
    ref_title: "Referidos", ref_copy: "Gana $25 por la tarifa de activación de cada trader referido.",
    ref_enter_code: "INGRESAR CÓDIGO", ref_share_link: "COMPARTIR ENLACE", ref_withdraw: "RETIRAR RECOMPENSA",
    ref_traders_referred: "TRADERS REFERIDOS", ref_rewards_earned: "RECOMPENSAS GANADAS", ref_withdrawable: "RECOMPENSA RETIRABLE", ref_min_required: "Mínimo $125 requerido",
    ref_history: "Historial de referidos", ref_email: "EMAIL", ref_date_joined: "FECHA DE INGRESO", ref_fee_paid: "TARIFA PAGADA", ref_your_reward: "TU RECOMPENSA",
    ref_modal_share_title: "Comparte tu enlace de referido",
    ref_copy_btn: "COPIAR", ref_copied_btn: "COPIADO",
    ref_modal_code_title: "Ingresar código de referido",
    ref_code_placeholder: "Pegar código o enlace de referido",
    ref_stepper_request: "SOLICITAR", ref_stepper_review: "REVISAR", ref_stepper_wallet: "BILLETERA",
    ref_withdraw_title: "Retirar recompensa",
    ref_withdrawable_label: "RETIRABLE",
    ref_amount_label: "Monto a retirar",
    ref_max_prefix: "MÁX:",
    ref_min_text: "Mínimo $125 requerido",
    ref_wallet_label: "Dirección ERC20 de USDC",
    ref_continue_btn: "CONTINUAR",
    ref_review_title: "Revisar solicitud",
    ref_erc20_label: "DIRECCIÓN ERC-20",
    ref_amount_field: "MONTO",
    ref_currency_label: "MONEDA",
    ref_processing_label: "PROCESAMIENTO",
    ref_processing_time: "24H (EXCLUYENDO FINES DE SEMANA)",
    ref_confirm_btn: "CONFIRMAR RETIRO",
    ref_back_btn: "ATRÁS",
    ref_success_title: "Retiro enviado",
    ref_success_subtitle: "Tu USDC está en camino. Generalmente llega en 24 horas.",
    ref_reference_label: "REFERENCIA",
    ref_email_sent: "Te enviaremos un email en cuanto se haya enviado",
    port_title: "Cartera", port_waiting_account: "Ahora mismo no quedan cuentas de trading. Estás en la cola: te asignaremos una automáticamente y te enviaremos un correo en cuanto haya una libre, aunque cierres esta página.", port_overview: "RESUMEN", port_balance: "SALDO", port_profit_loss: "GANANCIA/PÉRDIDA", port_drawdown: "DRAWDOWN", port_rank: "RANGO", port_share: "COMPARTIR",
    port_trading_obj: "OBJETIVOS DE TRADING", port_in_range: "EN RANGO",
    port_max_drawdown: "DRAWDOWN MÁXIMO", port_of_initial: "del balance inicial",
    port_daily_loss: "LÍMITE DE PÉRDIDA DIARIA", port_of_starting: "del balance del día de inicio",
    port_monthly_profit: "GANANCIA MENSUAL MÁXIMA",
    port_withdrawal_hist: "HISTORIAL DE RETIROS", port_date: "FECHA", port_payout_amount: "MONTO DE PAGO", port_status: "ESTADO", port_tx_id: "ID DE TRANSACCIÓN", port_completed: "COMPLETADO", port_view_all: "Ver todos los retiros",
    port_account_details: "DETALLES DE LA CUENTA", port_login: "INICIO DE SESIÓN", port_master_pw: "CONTRASEÑA MAESTRA", port_investor_pw: "CONTRASEÑA DE INVERSOR", port_mt5_server: "SERVIDOR MT5", port_next_payout: "PRÓXIMO PAGO ELEGIBLE", port_request_payout: "SOLICITAR PAGO",
    port_prop_value: "VALOR PROP", port_current_value: "VALOR ACTUAL", port_usdc_per_prop: "USDC por $PROP", port_30d_change: "CAMBIO 30D",
    port_help_center: "CENTRO DE AYUDA", port_docs: "DOCUMENTOS", port_discord: "DISCORD",
    port_show_pw: "Mostrar contraseña", port_hide_pw: "Ocultar contraseña",
    port_activate_title: "Activa tu cuenta prop de 10,000",
    port_one_time_fee: "Pago único",
    port_profit_share: "100% de participación en ganancias",
    port_about_title: "Sobre PropFunding",
    port_no_consistency: "Sin reglas de consistencia",
    port_no_min_days: "Apalancamiento 1:10 disponible",
    port_biweekly: "Retiros quincenales",
    port_zero_comms: "$0 comisiones y spreads raw",
    port_forex_available: "Opera forex principales, menores y oro",
    port_platform_stats: "ESTADÍSTICAS DE LA PLATAFORMA",
    port_total_funded_stat: "TOTAL DE TRADERS FINANCIADOS",
    port_pool_balance_stat: "BALANCE DEL POOL",
    port_total_payouts_stat: "TOTAL DE PAGOS USDC",
    port_prop_value_stat_label: "VALOR $PROP",
    port_stat_week: "+23 esta semana",
    port_stat_backed: "Respaldado por capital real",
    port_stat_this_week: "Esta semana",
    port_stat_7d: "+2.41% (7D)",
    port_real_payouts_title: "TRADERS REALES Y PAGOS REALES",
    port_payout_modal_title: "Solicitar pago",
    port_available_withdraw: "DISPONIBLE PARA RETIRAR",
    port_prop_amount_label: "Monto a retirar en $PROP",
    port_prop_min_error: "Mínimo de {min} requerido",
    port_prop_max_error: "Supera el saldo disponible",
    port_prop_min_placeholder: "Mín. {min}",
    port_payout_min_tooltip: "Monto mínimo de retiro: {min} PRP (2% del tamaño de tu cuenta).",
    port_prop_min_note: "Se requiere un mínimo del 2% de retiro",
    port_you_receive: "RECIBIRÁS",
    port_paste_address: "Pegar dirección",
    port_payout_request_label: "SOLICITUD DE PAGO",
    port_payout_rate_label: "TASA",
    port_usdc_redeemed_label: "USDC REDIMIDOS",
    port_processing_fee_label: "TARIFA DE PROCESAMIENTO",
    port_net_payout_label: "PAGO NETO",
    port_confirm_payout_btn: "CONFIRMAR PAGO",
    port_payout_submitted_title: "Solicitud de pago enviada",
    port_payout_submitted_subtitle: "Nuestro equipo revisará tu solicitud. Las actualizaciones se proporcionan generalmente en 24 horas.",
    footer_cta_title: "Empieza a operar con el", footer_cta_highlight: "nuevo modelo",
    footer_cta_desc: "Únete a un sistema donde el rendimiento, no la plataforma, determina los resultados.",
    footer_cta_btn: "OBTENER FONDOS",
    share_modal_title: "Compartir posición en el clasificación",
    share_position_label: "Clasificación\nposición",
    share_prop_profit: "GANANCIA PRP", share_usdc_payouts: "PAGOS USDC", share_referral_code: "CÓDIGO DE REFERIDO",
    share_default_text: "Soy #{rank} en el Clasificación de PropFunding 🏆",
    share_field_referral: "Código de referido", share_field_text: "Personaliza tu texto",
    share_overlay: "Superposición", share_overlay_none: "Sin superposición", share_overlay_bull: "Superposición alcista", share_overlay_bear: "Superposición bajista",
    share_save: "GUARDAR IMAGEN", share_copy_link: "COPIAR ENLACE", share_on: "COMPARTIR EN",
    checkout_title: "Comprar cuenta financiada",
    checkout_payment_method: "Método de pago",
    checkout_card: "Tarjeta de crédito/débito", checkout_card_soon: "Tarjeta de crédito/débito (Próximamente)", checkout_crypto: "Cripto (USDC/USDT)",
    checkout_discount: "Código de descuento", checkout_apply: "APLICAR",
    checkout_summary: "Resumen", checkout_account: "Cuenta Prop $10K",
    checkout_discount_line: "Descuento", checkout_total: "TOTAL",
 checkout_card_number: "Número de tarjeta", checkout_expiry: "Vencimiento", checkout_cvv: "CVV", checkout_complete: "COMPLETAR", checkout_billing: "Datos de facturación", checkout_card_whop_text: "Introducirás los datos de tu tarjeta de forma segura en el siguiente paso.", checkout_crypto_whop_text: "Serás redirigido para pagar en USDC o USDT. Elige tu red en la página de pago y envía solo por esa red.", checkout_confirming: "Confirmando tu pago…", checkout_processing: "Tu pago se está procesando. Tu cuenta se activará en cuanto se confirme.", checkout_back_portfolio: "VOLVER AL PORTAFOLIO",
    cs_title: "Estado del pago", cs_loading: "Cargando tu pago…", cs_not_found: "No pudimos cargar este pago.", cs_awaiting: "Esperando el pago", cs_awaiting_desc: "Completa el pago en la página de pago. Esta página se actualiza automáticamente.", cs_confirming: "Confirmando", cs_confirming_desc: "Tu pago está en la blockchain. Estamos esperando su confirmación.", cs_partially_paid: "Pago parcial", cs_partially_paid_desc: "Recibimos parte de tu pago. Envía el monto restante desde la página de pago.", cs_paid: "Pagado", cs_paid_activation: "Pago recibido. Tu cuenta está activada.", cs_expired: "Vencido", cs_expired_desc: "Esta solicitud de pago venció. Si ya enviaste fondos, contacta a soporte. Si no, inicia un nuevo pago.", cs_needs_review: "En revisión", cs_needs_review_desc: "Recibimos tu pago y nuestro equipo lo está revisando. Te contactaremos pronto.", cs_amount_due: "Monto a pagar", cs_paid_so_far: "Pagado hasta ahora", cs_open_widget: "ABRIR PÁGINA DE PAGO", cs_network_warning: "Envía solo USDC o USDT, y solo por la red que elegiste en la página de pago. Los depósitos enviados por otra red se perderán.",
    checkout_funded_received: "Pago recibido. Estamos configurando tu cuenta fondeada y aparecerá en tu portafolio cuando esté lista.",


    port_tooltip_withdraw: "Monto máximo elegible para retiro basado en las ganancias netas de tu cuenta MT5, neto de las tarifas de procesamiento aplicables",
    port_tooltip_max_drawdown: "La pérdida máxima estática basada en tu saldo inicial. Si tu patrimonio alcanza este nivel, la cuenta se desactiva automáticamente",
    port_tooltip_daily_loss: "La pérdida máxima de patrimonio permitida en un solo día de operación. El límite de pérdida diaria incluye posiciones abiertas y cerradas",
    port_tooltip_monthly_profit: "La ganancia máxima que puedes retirar en un mes calendario. Se reinicia el 1º de cada mes",
    port_tooltip_balance: "Tu saldo total de cuenta liquidado en PRP después de las operaciones cerradas",
    port_tooltip_profit_loss: "Tu ganancia o pérdida realizada de las operaciones completadas",
    port_tooltip_drawdown: "Tu drawdown actual basado en posiciones perdedoras activas y cerradas",
    port_tooltip_rank: "Tu clasificación entre los traders activos de PropFunding",
    port_tooltip_prop_value: "Las ganancias elegibles en PRP se convierten a esta tasa fija al retirarlas",
    // Strings added after the first translation pass
    ref_payout_date: "FECHA DE PAGO",
    ref_status: "ESTADO",
    ref_tab_all: "Todos",
    ref_tab_claimed: "Reclamados",
    ref_status_trial: "Prueba",
    ref_status_activated: "Activado",
    ref_status_claimed: "Reclamado",
    ref_no_claimed: "Aún no hay recompensas reclamadas.",
    ref_no_referrals: "Aún no tienes referidos. Comparte tu enlace para empezar a ganar.",
    ref_loading: "Cargando tus referidos…",
    ref_load_error: "No pudimos cargar tus referidos.",
    ref_retry: "REINTENTAR",
    ref_using_code: "Estás usando el código: {code}",
    share_saving: "GUARDANDO…",
    share_loading: "Cargando imagen",
    share_discord_copied: "Publicación copiada. Pégala en Discord.",
    share_failed: "No funcionó. Inténtalo de nuevo.",
    help_title: "Centro de ayuda",
    help_subtitle: "Obtén ayuda con tu cuenta y sigue tus solicitudes de soporte.",
    help_report_issue: "Reportar problema",
    help_report_issue_title: "Reportar problema",
    help_search_placeholder: "Buscar artículos de ayuda",
    help_support_tickets: "Tickets de soporte",
    help_tab_open: "Abiertos",
    help_tab_resolved: "Resueltos",
    help_issue: "Problema",
    help_category: "Categoría",
    help_submitted: "Enviado",
    help_status: "Estado",
    help_action: "Acción",
    help_status_in_progress: "En curso",
    help_status_resolved: "Resuelto",
    help_see_details: "Ver detalles",
    help_manage: "Gestionar",
    help_no_tickets: "No hay tickets aquí.",
    help_faq: "Preguntas frecuentes",
    help_articles: "artículos",
    help_popular_articles: "Artículos populares",
    help_no_results: "Ningún artículo coincide con tu búsqueda.",
    help_ticket_details: "Detalles del ticket",
    help_ticket_id: "ID del ticket",
    help_description: "Descripción",
    help_attachment: "Adjunto",
    help_original_message: "Mensaje original",
    help_additional_detail: "Detalle adicional",
    help_original_attachment: "Adjunto original",
    help_additional_attachment: "Adjunto adicional",
    help_need_more_info: "¿Necesitas añadir información?",
    help_add_details_placeholder: "Añade más detalles...",
    help_upload_screenshot: "Subir captura de pantalla",
    help_add_update: "Añadir actualización",
    help_status_sent: "Enviado",
    help_select_category: "Selecciona una categoría",
    help_issue_description: "Descripción del problema",
    help_issue_description_hint: "Describe el problema en detalle.",
    help_describe_placeholder: "Describe el problema que tienes...",
    help_attachment_optional: "Adjunto (opcional)",
    help_attachment_hint: "Sube una captura de pantalla para ayudarnos a entender el problema más rápido.",
    help_upload_or_drag: "Sube o arrastra un archivo",
    help_cancel: "Cancelar",
    help_submit_issue: "Enviar problema",
    help_issue_reported: "Problema reportado",
    help_issue_reported_note: "Tu problema se ha reportado correctamente. Revisa la sección del centro de ayuda para ver las novedades.",
    help_report_another: "Reportar otro",
    help_done: "Listo",
    help_report_category_issue: "Reportar problema de {category}",
    help_articles_title: "Artículos",
    help_team_reply: "Respuesta del equipo de soporte", help_loading: "Cargando…", help_sending: "Enviando…", help_tickets_error: "No pudimos cargar tus tickets.", help_try_again: "Reintentar",
    port_free_title: "Entrada gratuita. Un objetivo.",
    port_free_desc: "Alcanza +1% en tu cuenta de 10,000 PRP para calificar para la activación.",
    port_start_trading: "EMPEZAR A OPERAR",
    port_getting_ready: "Preparando tu cuenta...",
    port_free_accounts_stat: "CUENTAS GRATUITAS INICIADAS",
    port_qualified_stat: "TRADERS CALIFICADOS",
    port_activated_stat: "CUENTAS ACTIVADAS",
    port_total_paid_stat: "TOTAL DE USDC PAGADO",
    port_tooltip_free_accounts: "Número total de cuentas gratuitas de 10,000 PRP iniciadas en PropFunding",
    port_tooltip_qualified: "Traders que alcanzaron el objetivo de calificación de +1%",
    port_tooltip_activated: "Cuentas calificadas que pagaron la tarifa de activación y completaron el KYC",
    port_tooltip_total_paid: "Total de USDC pagado a los traders de PropFunding",
    port_inactivity: "INACTIVIDAD",
    port_tooltip_inactivity: "Debes operar al menos una vez cada 14 días o tu cuenta se desactivará",
    port_qualifying_target: "OBJETIVO DE CALIFICACIÓN",
    port_tooltip_qualifying: "Haz crecer tu cuenta de 10,000 PRP un 1% para calificar para la activación",
    port_min_trading_days: "DÍAS MÍNIMOS DE TRADING",
    port_tooltip_min_days: "Tu cuenta necesita al menos 3 días de trading para calificar",
    port_achieved: "logrado",
    port_reached: "alcanzado",
    port_days: "días",
    port_process: "EL PROCESO",
    port_how_it: "Cómo",
    port_works: "funciona",
    port_step1_title: "Empieza gratis",
    port_step1_desc: "Empieza a operar tu cuenta de 10,000 PRP sin tarifa inicial.",
    port_step2_title: "Alcanza +1%",
    port_step2_desc: "Haz crecer tu cuenta un 1% para calificar. Las cuentas necesitan al menos 3 días de trading para calificar.",
    port_step3_title: "Activa y verifica",
    port_step3_desc: "Paga la tarifa de activación en un plazo de 48 horas y completa tu KYC.",
    port_step4_title: "Canjea en USDC",
    port_step4_desc: "Retira tu ganancia de calificación de +1% en USDC al activar. Tu cuenta se reinicia y los retiros estándar comienzan después de 14 días.",
    port_mt5_account_details: "DATOS DE LA CUENTA MT5",
    port_usdc_per_prp: "USDC por PRP",
    port_hit_target: "Alcanzaste el 1%.",
    port_time_to_activate: "Es hora de activar.",
    port_activate_desc: "Activa en un plazo de 48 horas para desbloquear tu cuenta financiada y retirar tu ganancia de calificación del 1%.",
    port_activate_soon: "Activa pronto –",
    port_time_running_out: "se acaba el tiempo",
    port_activate_urgent_desc: "Corres el riesgo de perder tu cuenta financiada. Paga la tarifa de activación en un plazo de 24 horas para evitarlo.",
    port_window_title: "Plazo de activación",
    port_window_expired: "vencido",
    port_window_expired_desc: "Tu plazo de activación de 48 horas ha vencido. Esta calificación ya no se puede activar.",
    port_qualification_result: "RESULTADO DE CALIFICACIÓN",
    port_qualification_reached: "+1% alcanzado",
    port_qualification_redemption: "CANJE DE CALIFICACIÓN",
    port_expired_value: "Vencido",
    port_activation_status: "ESTADO DE ACTIVACIÓN",
    port_expired_status: "VENCIDO",
    port_expired_on: "Venció el {date} a las {time}",
    port_start_next_attempt: "INICIAR SIGUIENTE INTENTO GRATIS",
    port_activation_fee: "TARIFA DE ACTIVACIÓN",
    port_redeem_after_activation: "CANJE DISPONIBLE TRAS LA ACTIVACIÓN",
    port_redeem_after_activation_short: "CANJE TRAS LA ACTIVACIÓN",
    port_time_left: "TIEMPO RESTANTE PARA ACTIVAR",
    port_hours: "horas",
    port_minutes: "minutos",
    port_seconds: "segundos",
    port_activate_short: "ACTIVAR",
    checkout_claim_title: "Paga para reclamar tu cuenta financiada",
    checkout_card_with_fee: "Tarjeta de crédito/débito (comisión de procesamiento del 2.9%)",
    checkout_card_with_fee_short: "Tarjeta de crédito/débito (comisión del 2.9%)",
    checkout_activation_account: "Cuenta Prop de $10K",
    checkout_card_fee: "Comisión de procesamiento de tarjeta",
    checkout_crypto_plain: "Cripto",
    port_next_steps: "PRÓXIMOS PASOS",
    port_pending: "PENDIENTE",
    port_next_verify_title: "Verifica tu identidad",
    port_next_verify_desc: "Verificación KYC rápida para desbloquear los pagos.",
    port_next_withdraw_title: "Retira tu 1%",
    port_next_withdraw_desc: "Tu recompensa por alcanzar el objetivo de calificación.",
    port_next_trade_title: "Sigue operando",
    port_next_trade_desc: "Persigue el próximo hito en el mercado.",
    port_kyc_title: "VERIFICACIÓN KYC",
    port_kyc_required: "DOCUMENTOS REQUERIDOS",
    port_kyc_doc_id: "Documento de identidad (pasaporte, licencia de conducir, identificación oficial).",
    port_kyc_doc_address: "Comprobante de domicilio (factura de servicios, factura de teléfono, extracto bancario).",
    port_kyc_start: "INICIAR VERIFICACIÓN DE IDENTIDAD",
    port_kyc_error: "ERROR DE VERIFICACIÓN",
    port_kyc_error_desc: "No pudimos verificar tu identidad.",
    port_kyc_try_again: "REINTENTAR",
    port_kyc_contact_support: "Contactar con soporte",
    port_kyc_pending: "EN REVISIÓN",
    port_kyc_pending_desc: "Estamos revisando tus documentos. Suele tardar unos minutos; actualizaremos esta tarjeta cuando termine.",
    port_kyc_rejected_desc: "No pudimos verificar tu identidad y esta verificación no se puede repetir. Contacta con soporte.",
    port_kyc_loading: "Iniciando verificación...",
    port_withdraw_profit: "RETIRAR GANANCIA",
    port_to_withdraw: "PARA RETIRAR",
    port_tooltip_to_withdraw: "Tu ganancia de calificación de +1%, canjeable en USDC",
    port_max_withdraw_note: "Retiro máximo permitido del 1%",
    port_rule_title_max_drawdown: "Drawdown máximo",
    port_rule_title_daily_loss: "Pérdida diaria",
    port_rule_title_inactivity: "Regla de inactividad",
    port_rule_name_max_drawdown: "drawdown máximo",
    port_rule_name_daily_loss: "límite de pérdida diaria",
    port_rule_name_inactivity: "regla de inactividad",
    port_and: "y",
    port_breach_desc_prefix: "Tu cuenta superó el",
    port_breach_desc_inactivity: "Tu cuenta incumplió la regla de inactividad.",
    port_breach_retry_left: "Te queda un reintento gratis más.",
    port_free_retry: "REINTENTO GRATIS",
    port_prp_value: "VALOR DE PRP",
    port_breached: "incumplido",
    port_exhausted_title: "Tus intentos gratuitos han terminado",
    port_exhausted_desc: "Has agotado tus reintentos gratuitos.",
    port_exhausted_offer: "Aún puedes activar una cuenta financiada al instante por",
    port_promo_prefix: "Usa el código",
    port_promo_suffix: "para obtener un 10% de descuento.",
    port_offer_title: "🎉 OFERTA DE PRIMERA ACTIVACIÓN",
    port_offer_desc: "Usa {code} al pagar para obtener un 10% de descuento en tu primera activación.",
    port_offer_copy: "COPIAR CÓDIGO",
    port_offer_copied: "COPIADO",
    port_offer_remaining: "Quedan {left} de {total} usuarios",
    port_get_funded_for: "OBTÉN FINANCIACIÓN POR",
    port_get_funded: "OBTÉN FINANCIACIÓN",
    port_cycle_ended_title: "Ciclo de trading finalizado",
    port_cycle_ended_desc: "Tu cuenta superó los límites de drawdown máximo y de pérdida diaria.",
    port_promo_new_account: "para obtener un 10% de descuento en tu nueva cuenta.",
    port_get_funded_again: "OBTÉN FINANCIACIÓN DE NUEVO",
    port_previous_cycle: "CICLO ANTERIOR",
    port_drawdown_reached: "Drawdown alcanzado",
    port_daily_loss_reached: "Pérdida diaria alcanzada",
    port_final_equity: "Equity final",
    port_what_we_offer: "LO QUE OFRECEMOS",
    port_offer_free_title: "Empieza gratis",
    port_offer_free_desc: "Paga solo después de alcanzar +1%.",
    port_offer_loss_title: "Pérdida máxima estática del 20%",
    port_offer_loss_desc: "Más margen para operar.",
    port_offer_share_title: "100% de reparto de ganancias",
    port_offer_share_desc: "1 PRP = 0.50 USDC.",
    port_previous_payouts: "PAGOS ANTERIORES",
    port_view_all_payouts: "Ver todos los pagos",
    port_help_intro: "Nuestro equipo está aquí si necesitas algo.",
    port_redemption_note: "De {prp} PRP a una tasa de canje de {rate} USDC",
    port_erc20_label: "DIRECCIÓN USDC ERC20",
    port_payout_review_note: "Espera 24 horas para la revisión. Una vez aprobado, se sincronizará tu nueva cuenta MT5.",
    acc_full_name: "Nombre completo",
    acc_email: "Correo electrónico",
    acc_save: "GUARDAR",
    acc_saving: "GUARDANDO…",
    acc_saved: "Guardado.",
    port_mt5_download: "Descargar MT5",
    menu_dark_mode: "Modo oscuro",
    menu_join_discord: "ÚNETE A LA COMUNIDAD DE DISCORD",
    menu_logout: "CERRAR SESIÓN",
  },

  PT: {
    nav_portfolio: "Portfólio", nav_stats: "Estatísticas", nav_leaderboard: "Classificação", nav_referrals: "Indicações", nav_account: "Conta", nav_help: "Central de ajuda",
    header_docs: "DOCUMENTAÇÃO", header_support: "SUPORTE", header_switch_theme: "MUDAR TEMA", header_language: "Idioma", header_edit_name: "Editar nome", header_save_change: "SALVAR ALTERAÇÃO",
    footer_online: "ONLINE", footer_docs: "Documentação", footer_support: "Suporte", footer_terms: "Termos", footer_privacy: "Privacidade",
    stats_title: "Estatísticas",
    stats_subtitle: "Atividade ao vivo no ecossistema PropFunding.",
    stats_free_accounts: "CONTAS GRATUITAS INICIADAS",
    stats_qualified: "TRADERS QUALIFICADOS",
    stats_activated: "CONTAS ATIVADAS",
    stats_usdc_paid: "TOTAL USDC PAGO",
    stats_tip_free: "Contas gratuitas de 10.000 PRP abertas até hoje",
    stats_tip_qualified: "Traders que atingiram a meta de 1% e cumpriram todas as outras regras de trading",
    stats_tip_activated: "Contas ativadas após a qualificação",
    stats_tip_usdc_paid: "USDC pago aos traders até hoje",
    stats_history_label: "HISTÓRICO",
    stats_qual_title: "Atividade de qualificação",
    stats_qual_desc: "Traders atingindo +1% ao longo do tempo.",
    stats_fee_title: "Para onde vai sua taxa de ativação",
    stats_fee_onetime: "TAXA DE ATIVAÇÃO ÚNICA",
    stats_fee_onetime_desc: "Paga só depois de atingir +1%",
    stats_fee_badge: "Grátis para se qualificar",
    stats_fee_pool: "Fundo de saques",
    stats_fee_pool_desc: "Reservado antes do início dos saques",
    stats_fee_returned: "Devolvido a você",
    stats_fee_returned_desc: "Seu +1% é pago em USDC na ativação",
    stats_fee_platform: "Plataforma",
    stats_fee_platform_desc: "Verificação, pagamentos e suporte",
    stats_fee_note: "A receita das contas não é tratada como um único fundo operacional. O capital é separado para apoiar a liquidez, a gestão da exposição e a sustentabilidade a longo prazo.",
    stats_redemptions_label: "RESGATES",
    stats_redemptions_title: "USDC pago aos traders",
    stats_redemptions_desc: "Resgates de qualificação e saques padrão.",
    stats_outcomes_label: "RESULTADOS DAS CONTAS",
    stats_breaches_title: "Violações",
    stats_breaches_desc: "Contas que atingiram um limite de perda.",
    stats_rules_label: "REGRAS DA PLATAFORMA",
    stats_rule_max_loss: "PERDA MÁXIMA",
    stats_rule_max_loss_desc: "Perda máxima estática a partir do saldo inicial.",
    stats_rule_daily: "LIMITE DE PERDA DIÁRIA",
    stats_rule_daily_desc: "Perda máxima diária do patrimônio.",
    stats_rule_withdraw: "LIMITE DE SAQUE",
    stats_rule_withdraw_desc: "Máximo a cada 28 dias corridos.",
    stats_rule_rate: "TAXA DE RESGATE",
    stats_rule_rate_desc: "Fixa em cada resgate elegível.",
    stats_transparency_label: "TRANSPARÊNCIA",
    stats_transparency_title: "Nada escondido",
    stats_transparency_desc: "Tudo o que você precisa saber está visível antes de operar.",
    stats_target_title: "A meta",
    stats_target_desc: "+1% para se qualificar.",
    stats_rate_title: "A taxa",
    stats_rate_desc: "1 PRP = 0,50 USDC.",
    stats_limits_title: "Os limites",
    stats_limits_desc: "20% de perda máxima estática, 5% de perda diária.",
    stats_cta_title: "Feito para financiar vencedores",
    stats_year_filter: "Filtrar por ano",
    stats_loading: "Carregando estatísticas…",
    stats_load_error: "Não foi possível carregar as estatísticas.",
    stats_no_data: "Ainda não há dados.",
    stats_no_payouts: "Ainda não há pagamentos.",

    stats_section_overview: "VISÃO GERAL DA PLATAFORMA",






    stats_daily_dd_breach: "Violação de DD diário", stats_max_dd_breach: "Violação de DD máximo",





    lb_active_traders: "TRADERS ATIVOS",
    lb_qualified_traders: "TRADERS QUALIFICADOS",
    lb_total_prp: "PRP TOTAL",
    lb_total_usdc_paid: "TOTAL USDC PAGO",
    lb_usdc_paid: "USDC PAGO",
    lb_tip_active: "Traders com conta aberta neste ciclo",
    lb_tip_qualified: "Traders que atingiram a meta de 1% e cumpriram todas as outras regras de trading",
    lb_tip_total_prp: "Patrimônio combinado das contas PRP de todos os traders ativos.",
    lb_tip_usdc_paid: "USDC pago aos traders até hoje",
    lb_tip_prp_profit: "É o total acumulado de PRP que eles ganharam.",
    lb_no_results: "Nenhum resultado para “{query}”",
    lb_loading: "Carregando o ranking…",
    lb_load_error: "Não foi possível carregar o ranking.",
    lb_empty: "Ainda não há traders no ranking.",
    lb_you: "você",
    lb_cta_title: "Pronto para entrar na",
    lb_cta_highlight: "classificação?",
    lb_cta_desc: "Sem taxa inicial, sem regra de consistência e um valor fixo em USDC para cada PRP elegível que você ganhar.",
    lb_cta_desc_mobile: "Comece grátis com uma conta de 10.000 PRP e prove sua vantagem.",
    lb_cta_btn: "COMEÇAR GRÁTIS",
    share_text_line2: "Comece a operar grátis com Propfunding.com",
    lb_title: "Classificação", lb_live: "AO VIVO", lb_live_update: "Atualiza a cada 5 minutos", lb_your_position: "SUA POSIÇÃO", lb_share: "COMPARTILHAR", lb_traders: "Traders", lb_search: "Buscar traders",
    lb_rank: "POSIÇÃO", lb_name: "NOME", lb_prop_profit: "LUCRO PRP", lb_status: "STATUS", lb_usdc_payouts: "PAGAMENTOS USDC", lb_daily_dd: "DD DIÁRIO", lb_max_dd: "DD MÁXIMO",
    lb_status_active: "ATIVO", lb_status_critical: "CRÍTICO", lb_status_breached: "VIOLADO",
    lb_pool_balance: "SALDO DO POOL", lb_funded_traders: "TRADERS FINANCIADOS", lb_total_profit: "LUCRO TOTAL EM $PROP", lb_total_payouts: "TOTAL PAGAMENTOS USDC",
    lb_detail_week: "$8.400 esta semana", lb_detail_month: "-12 este mês", lb_detail_across: "Em todas as contas financiadas", lb_detail_5k_cycle: "$5.000 no último ciclo",
    ref_title: "Indicações", ref_copy: "Ganhe $25 pela taxa de ativação de cada trader indicado.",
    ref_enter_code: "INSERIR CÓDIGO", ref_share_link: "COMPARTILHAR LINK", ref_withdraw: "SACAR RECOMPENSA",
    ref_traders_referred: "TRADERS INDICADOS", ref_rewards_earned: "RECOMPENSAS GANHAS", ref_withdrawable: "RECOMPENSA SACÁVEL", ref_min_required: "Mínimo de $125 necessário",
    ref_history: "Histórico de indicações", ref_email: "EMAIL", ref_date_joined: "DATA DE ENTRADA", ref_fee_paid: "TAXA PAGA", ref_your_reward: "SUA RECOMPENSA",
    ref_modal_share_title: "Compartilhe seu link de indicação",
    ref_copy_btn: "COPIAR", ref_copied_btn: "COPIADO",
    ref_modal_code_title: "Inserir código de indicação",
    ref_code_placeholder: "Colar código ou link de indicação",
    ref_stepper_request: "SOLICITAR", ref_stepper_review: "REVISAR", ref_stepper_wallet: "CARTEIRA",
    ref_withdraw_title: "Sacar recompensa",
    ref_withdrawable_label: "SACÁVEL",
    ref_amount_label: "Valor a sacar",
    ref_max_prefix: "MÁX:",
    ref_min_text: "Mínimo de $125 necessário",
    ref_wallet_label: "Endereço ERC20 USDC",
    ref_continue_btn: "CONTINUAR",
    ref_review_title: "Revisar solicitação",
    ref_erc20_label: "ENDEREÇO ERC-20",
    ref_amount_field: "VALOR",
    ref_currency_label: "MOEDA",
    ref_processing_label: "PROCESSAMENTO",
    ref_processing_time: "24H (EXCLUINDO FINS DE SEMANA)",
    ref_confirm_btn: "CONFIRMAR SAQUE",
    ref_back_btn: "VOLTAR",
    ref_success_title: "Saque enviado",
    ref_success_subtitle: "Seu USDC está a caminho. Normalmente chega em 24 horas.",
    ref_reference_label: "REFERÊNCIA",
    ref_email_sent: "Enviaremos um e-mail assim que for enviado",
    port_title: "Portfólio", port_waiting_account: "No momento não há contas de trading disponíveis. Você está na fila: vamos atribuir uma automaticamente e avisar por e-mail assim que houver uma livre, mesmo que feche esta página.", port_overview: "VISÃO GERAL", port_balance: "SALDO", port_profit_loss: "LUCRO/PERDA", port_drawdown: "DRAWDOWN", port_rank: "POSIÇÃO", port_share: "COMPARTILHAR",
    port_trading_obj: "OBJETIVOS DE NEGOCIAÇÃO", port_in_range: "DENTRO DO LIMITE",
    port_max_drawdown: "DRAWDOWN MÁXIMO", port_of_initial: "do saldo inicial",
    port_daily_loss: "LIMITE DE PERDA DIÁRIA", port_of_starting: "do saldo inicial do dia",
    port_monthly_profit: "LUCRO MENSAL MÁXIMO",
    port_withdrawal_hist: "HISTÓRICO DE SAQUES", port_date: "DATA", port_payout_amount: "VALOR DO PAGAMENTO", port_status: "STATUS", port_tx_id: "ID DA TRANSAÇÃO", port_completed: "CONCLUÍDO", port_view_all: "Ver todos os saques",
    port_account_details: "DETALHES DA CONTA", port_login: "LOGIN", port_master_pw: "SENHA MESTRA", port_investor_pw: "SENHA DE INVESTIDOR", port_mt5_server: "SERVIDOR MT5", port_next_payout: "PRÓXIMO PAGAMENTO ELEGÍVEL", port_request_payout: "SOLICITAR PAGAMENTO",
    port_prop_value: "VALOR PROP", port_current_value: "VALOR ATUAL", port_usdc_per_prop: "USDC por $PROP", port_30d_change: "VARIAÇÃO 30D",
    port_help_center: "CENTRAL DE AJUDA", port_docs: "DOCUMENTAÇÃO", port_discord: "DISCORD",
    port_show_pw: "Mostrar senha", port_hide_pw: "Ocultar senha",
    port_activate_title: "Ative sua conta prop de 10.000",
    port_one_time_fee: "Taxa única",
    port_profit_share: "100% de participação nos lucros",
    port_about_title: "Sobre a PropFunding",
    port_no_consistency: "Sem regras de consistência",
    port_no_min_days: "Alavancagem 1:10 disponível",
    port_biweekly: "Saques quinzenais",
    port_zero_comms: "$0 comissões e spreads raw",
    port_forex_available: "Negocie forex principais, menores e ouro",
    port_platform_stats: "ESTATÍSTICAS DA PLATAFORMA",
    port_total_funded_stat: "TOTAL DE TRADERS FINANCIADOS",
    port_pool_balance_stat: "SALDO DO POOL",
    port_total_payouts_stat: "TOTAL DE PAGAMENTOS USDC",
    port_prop_value_stat_label: "VALOR $PROP",
    port_stat_week: "+23 esta semana",
    port_stat_backed: "Apoiado por capital real",
    port_stat_this_week: "Esta semana",
    port_stat_7d: "+2.41% (7D)",
    port_real_payouts_title: "TRADERS REAIS E PAGAMENTOS REAIS",
    port_payout_modal_title: "Solicitar pagamento",
    port_available_withdraw: "DISPONÍVEL PARA SAQUE",
    port_prop_amount_label: "Valor a sacar em $PROP",
    port_prop_min_error: "Mínimo de {min} obrigatório",
    port_prop_max_error: "Excede o saldo disponível",
    port_prop_min_placeholder: "Mín. {min}",
    port_payout_min_tooltip: "Valor mínimo de saque: {min} PRP (2% do tamanho da sua conta).",
    port_prop_min_note: "Mínimo de 2% de saque obrigatório",
    port_you_receive: "VOCÊ RECEBE",
    port_paste_address: "Colar endereço",
    port_payout_request_label: "SOLICITAÇÃO DE PAGAMENTO",
    port_payout_rate_label: "TAXA",
    port_usdc_redeemed_label: "USDC RESGATADO",
    port_processing_fee_label: "TAXA DE PROCESSAMENTO",
    port_net_payout_label: "PAGAMENTO LÍQUIDO",
    port_confirm_payout_btn: "CONFIRMAR PAGAMENTO",
    port_payout_submitted_title: "Solicitação de pagamento enviada",
    port_payout_submitted_subtitle: "Nossa equipe analisará sua solicitação. As atualizações são geralmente fornecidas em 24 horas.",
    footer_cta_title: "Comece a operar com o", footer_cta_highlight: "novo modelo",
    footer_cta_desc: "Junte-se a um sistema onde o desempenho, não a plataforma, determina os resultados.",
    footer_cta_btn: "OBTER FUNDOS",
    share_modal_title: "Compartilhar posição no classificação",
    share_position_label: "Classificação\nposição",
    share_prop_profit: "LUCRO PRP", share_usdc_payouts: "PAGAMENTOS USDC", share_referral_code: "CÓDIGO DE INDICAÇÃO",
    share_default_text: "Sou #{rank}º no Classificação da PropFunding 🏆",
    share_field_referral: "Código de indicação", share_field_text: "Personalize seu texto",
    share_overlay: "Sobreposição", share_overlay_none: "Sem sobreposição", share_overlay_bull: "Sobreposição altista", share_overlay_bear: "Sobreposição baixista",
    share_save: "SALVAR IMAGEM", share_copy_link: "COPIAR LINK", share_on: "COMPARTILHAR EM",
    checkout_title: "Comprar conta financiada",
    checkout_payment_method: "Método de pagamento",
    checkout_card: "Cartão de crédito/débito", checkout_card_soon: "Cartão de crédito/débito (Em breve)", checkout_crypto: "Cripto (USDC/USDT)",
    checkout_discount: "Código de desconto", checkout_apply: "APLICAR",
    checkout_summary: "Resumo", checkout_account: "Conta Prop $10K",
    checkout_discount_line: "Desconto", checkout_total: "TOTAL",
 checkout_card_number: "Número do cartão", checkout_expiry: "Validade", checkout_cvv: "CVV", checkout_complete: "CONCLUIR", checkout_billing: "Dados de cobrança", checkout_card_whop_text: "Você informará os dados do seu cartão com segurança na próxima etapa.", checkout_crypto_whop_text: "Você será redirecionado para pagar em USDC ou USDT. Escolha sua rede na página de pagamento e envie apenas por essa rede.", checkout_confirming: "Confirmando seu pagamento…", checkout_processing: "Seu pagamento está sendo processado. Sua conta será ativada assim que for confirmado.", checkout_back_portfolio: "VOLTAR AO PORTFÓLIO",
    cs_title: "Status do pagamento", cs_loading: "Carregando seu pagamento…", cs_not_found: "Não foi possível carregar este pagamento.", cs_awaiting: "Aguardando pagamento", cs_awaiting_desc: "Conclua o pagamento na página de pagamento. Esta página é atualizada automaticamente.", cs_confirming: "Confirmando", cs_confirming_desc: "Seu pagamento está na blockchain. Estamos aguardando a confirmação.", cs_partially_paid: "Pago parcialmente", cs_partially_paid_desc: "Recebemos parte do seu pagamento. Envie o valor restante pela página de pagamento.", cs_paid: "Pago", cs_paid_activation: "Pagamento recebido. Sua conta está ativada.", cs_expired: "Expirado", cs_expired_desc: "Esta solicitação de pagamento expirou. Se você já enviou fundos, fale com o suporte. Caso contrário, inicie um novo checkout.", cs_needs_review: "Em análise", cs_needs_review_desc: "Recebemos seu pagamento e nossa equipe está analisando. Entraremos em contato em breve.", cs_amount_due: "Valor devido", cs_paid_so_far: "Pago até agora", cs_open_widget: "ABRIR PÁGINA DE PAGAMENTO", cs_network_warning: "Envie apenas USDC ou USDT, e apenas pela rede escolhida na página de pagamento. Depósitos enviados por outra rede serão perdidos.",
    checkout_funded_received: "Pagamento recebido. Estamos configurando sua conta financiada e ela aparecerá no seu portfólio quando estiver pronta.",


    port_tooltip_withdraw: "Valor máximo elegível para saque com base no lucro líquido da sua conta MT5, líquido das taxas de processamento aplicáveis",
    port_tooltip_max_drawdown: "A perda máxima estática com base no seu saldo inicial. Se o seu patrimônio atingir este nível, a conta é desativada automaticamente",
    port_tooltip_daily_loss: "A perda máxima de patrimônio permitida em um único dia de negociação. O limite de perda diária inclui posições abertas e fechadas",
    port_tooltip_monthly_profit: "O lucro máximo que você pode sacar em um mês calendário. Reinicia no dia 1º de cada mês",
    port_tooltip_balance: "Seu saldo total da conta liquidado em PRP após as operações fechadas",
    port_tooltip_profit_loss: "Seu lucro ou perda realizado de operações concluídas",
    port_tooltip_drawdown: "Seu drawdown atual com base em posições perdedoras ativas e fechadas",
    port_tooltip_rank: "Sua classificação entre os traders ativos da PropFunding",
    port_tooltip_prop_value: "Os lucros elegíveis em PRP são convertidos a esta taxa fixa no saque",
    // Strings added after the first translation pass
    ref_payout_date: "DATA DO PAGAMENTO",
    ref_status: "STATUS",
    ref_tab_all: "Todos",
    ref_tab_claimed: "Resgatados",
    ref_status_trial: "Teste",
    ref_status_activated: "Ativado",
    ref_status_claimed: "Resgatado",
    ref_no_claimed: "Nenhuma recompensa resgatada ainda.",
    ref_no_referrals: "Nenhuma indicação ainda. Compartilhe seu link para começar a ganhar.",
    ref_loading: "Carregando suas indicações…",
    ref_load_error: "Não foi possível carregar suas indicações.",
    ref_retry: "TENTAR NOVAMENTE",
    ref_using_code: "Você está usando o código: {code}",
    share_saving: "SALVANDO…",
    share_loading: "Carregando imagem",
    share_discord_copied: "Post copiado. Cole no Discord.",
    share_failed: "Não funcionou. Tente novamente.",
    help_title: "Central de ajuda",
    help_subtitle: "Receba ajuda com sua conta e acompanhe suas solicitações de suporte.",
    help_report_issue: "Relatar problema",
    help_report_issue_title: "Relatar problema",
    help_search_placeholder: "Pesquisar artigos de ajuda",
    help_support_tickets: "Tickets de suporte",
    help_tab_open: "Abertos",
    help_tab_resolved: "Resolvidos",
    help_issue: "Problema",
    help_category: "Categoria",
    help_submitted: "Enviado",
    help_status: "Status",
    help_action: "Ação",
    help_status_in_progress: "Em andamento",
    help_status_resolved: "Resolvido",
    help_see_details: "Ver detalhes",
    help_manage: "Gerenciar",
    help_no_tickets: "Nenhum ticket aqui.",
    help_faq: "Perguntas frequentes",
    help_articles: "artigos",
    help_popular_articles: "Artigos populares",
    help_no_results: "Nenhum artigo corresponde à sua pesquisa.",
    help_ticket_details: "Detalhes do ticket",
    help_ticket_id: "ID do ticket",
    help_description: "Descrição",
    help_attachment: "Anexo",
    help_original_message: "Mensagem original",
    help_additional_detail: "Detalhe adicional",
    help_original_attachment: "Anexo original",
    help_additional_attachment: "Anexo adicional",
    help_need_more_info: "Precisa adicionar informações?",
    help_add_details_placeholder: "Adicione mais detalhes...",
    help_upload_screenshot: "Enviar captura de tela",
    help_add_update: "Adicionar atualização",
    help_status_sent: "Enviado",
    help_select_category: "Selecione a categoria",
    help_issue_description: "Descrição do problema",
    help_issue_description_hint: "Descreva o problema em detalhes.",
    help_describe_placeholder: "Descreva o problema que você está enfrentando...",
    help_attachment_optional: "Anexo (opcional)",
    help_attachment_hint: "Envie uma captura de tela para nos ajudar a entender o problema mais rápido.",
    help_upload_or_drag: "Envie ou arraste um arquivo",
    help_cancel: "Cancelar",
    help_submit_issue: "Enviar problema",
    help_issue_reported: "Problema relatado",
    help_issue_reported_note: "Seu problema foi relatado com sucesso. Acompanhe a seção da central de ajuda para ver atualizações.",
    help_report_another: "Relatar outro",
    help_done: "Concluído",
    help_report_category_issue: "Relatar problema de {category}",
    help_articles_title: "Artigos",
    help_team_reply: "Resposta da equipe de suporte", help_loading: "Carregando…", help_sending: "Enviando…", help_tickets_error: "Não conseguimos carregar seus tickets.", help_try_again: "Tentar novamente",
    port_free_title: "Entrada gratuita. Uma meta.",
    port_free_desc: "Alcance +1% na sua conta de 10,000 PRP para se qualificar para a ativação.",
    port_start_trading: "COMEÇAR A OPERAR",
    port_getting_ready: "Preparando sua conta...",
    port_free_accounts_stat: "CONTAS GRATUITAS INICIADAS",
    port_qualified_stat: "TRADERS QUALIFICADOS",
    port_activated_stat: "CONTAS ATIVADAS",
    port_total_paid_stat: "TOTAL DE USDC PAGO",
    port_tooltip_free_accounts: "Número total de contas gratuitas de 10,000 PRP iniciadas na PropFunding",
    port_tooltip_qualified: "Traders que alcançaram a meta de qualificação de +1%",
    port_tooltip_activated: "Contas qualificadas que pagaram a taxa de ativação e concluíram o KYC",
    port_tooltip_total_paid: "Total de USDC pago aos traders da PropFunding",
    port_inactivity: "INATIVIDADE",
    port_tooltip_inactivity: "Você precisa operar pelo menos uma vez a cada 14 dias ou sua conta será desativada",
    port_qualifying_target: "META DE QUALIFICAÇÃO",
    port_tooltip_qualifying: "Faça sua conta de 10,000 PRP crescer 1% para se qualificar para a ativação",
    port_min_trading_days: "DIAS MÍNIMOS DE TRADING",
    port_tooltip_min_days: "Sua conta precisa de pelo menos 3 dias de trading para se qualificar",
    port_achieved: "alcançado",
    port_reached: "atingido",
    port_days: "dias",
    port_process: "O PROCESSO",
    port_how_it: "Como",
    port_works: "funciona",
    port_step1_title: "Comece grátis",
    port_step1_desc: "Comece a operar sua conta de 10,000 PRP sem taxa inicial.",
    port_step2_title: "Alcance +1%",
    port_step2_desc: "Faça sua conta crescer 1% para se qualificar. As contas precisam de pelo menos 3 dias de trading para se qualificar.",
    port_step3_title: "Ative e verifique",
    port_step3_desc: "Pague a taxa de ativação em até 48 horas e conclua seu KYC.",
    port_step4_title: "Resgate em USDC",
    port_step4_desc: "Saque seu lucro de qualificação de +1% em USDC na ativação. Sua conta é reiniciada e os saques padrão começam após 14 dias.",
    port_mt5_account_details: "DADOS DA CONTA MT5",
    port_usdc_per_prp: "USDC por PRP",
    port_hit_target: "Você atingiu 1%.",
    port_time_to_activate: "Hora de ativar.",
    port_activate_desc: "Ative em até 48 horas para desbloquear sua conta financiada e sacar seu lucro de qualificação de 1%.",
    port_activate_soon: "Ative logo –",
    port_time_running_out: "o tempo está acabando",
    port_activate_urgent_desc: "Você corre o risco de perder sua conta financiada. Pague a taxa de ativação em até 24 horas para evitar isso.",
    port_window_title: "Prazo de ativação",
    port_window_expired: "expirado",
    port_window_expired_desc: "Seu prazo de ativação de 48 horas expirou. Esta qualificação não pode mais ser ativada.",
    port_qualification_result: "RESULTADO DA QUALIFICAÇÃO",
    port_qualification_reached: "+1% atingido",
    port_qualification_redemption: "RESGATE DA QUALIFICAÇÃO",
    port_expired_value: "Expirado",
    port_activation_status: "STATUS DA ATIVAÇÃO",
    port_expired_status: "EXPIRADO",
    port_expired_on: "Expirou em {date} às {time}",
    port_start_next_attempt: "INICIAR PRÓXIMA TENTATIVA GRÁTIS",
    port_activation_fee: "TAXA DE ATIVAÇÃO",
    port_redeem_after_activation: "RESGATE DISPONÍVEL APÓS A ATIVAÇÃO",
    port_redeem_after_activation_short: "RESGATE APÓS A ATIVAÇÃO",
    port_time_left: "TEMPO RESTANTE PARA ATIVAR",
    port_hours: "horas",
    port_minutes: "minutos",
    port_seconds: "segundos",
    port_activate_short: "ATIVAR",
    checkout_claim_title: "Pague para resgatar sua conta financiada",
    checkout_card_with_fee: "Cartão de crédito/débito (taxa de processamento de 2.9%)",
    checkout_card_with_fee_short: "Cartão de crédito/débito (taxa de 2.9%)",
    checkout_activation_account: "Conta Prop de $10K",
    checkout_card_fee: "Taxa de processamento do cartão",
    checkout_crypto_plain: "Cripto",
    port_next_steps: "PRÓXIMOS PASSOS",
    port_pending: "PENDENTE",
    port_next_verify_title: "Verifique sua identidade",
    port_next_verify_desc: "Verificação KYC rápida para liberar os pagamentos.",
    port_next_withdraw_title: "Saque seus 1%",
    port_next_withdraw_desc: "Sua recompensa por atingir a meta de qualificação.",
    port_next_trade_title: "Continue operando",
    port_next_trade_desc: "Busque o próximo marco no mercado.",
    port_kyc_title: "VERIFICAÇÃO KYC",
    port_kyc_required: "DOCUMENTOS NECESSÁRIOS",
    port_kyc_doc_id: "Documento de identidade (passaporte, carteira de motorista, documento oficial).",
    port_kyc_doc_address: "Comprovante de endereço (conta de consumo, conta de telefone, extrato bancário).",
    port_kyc_start: "INICIAR VERIFICAÇÃO DE IDENTIDADE",
    port_kyc_error: "ERRO NA VERIFICAÇÃO",
    port_kyc_error_desc: "Não foi possível verificar sua identidade.",
    port_kyc_try_again: "TENTAR NOVAMENTE",
    port_kyc_contact_support: "Falar com o suporte",
    port_kyc_pending: "EM ANÁLISE",
    port_kyc_pending_desc: "Estamos analisando seus documentos. Isso costuma levar alguns minutos; vamos atualizar este cartão quando terminar.",
    port_kyc_rejected_desc: "Não foi possível verificar sua identidade e esta verificação não pode ser repetida. Entre em contato com o suporte.",
    port_kyc_loading: "Iniciando verificação...",
    port_withdraw_profit: "SACAR LUCRO",
    port_to_withdraw: "PARA SACAR",
    port_tooltip_to_withdraw: "Seu lucro de qualificação de +1%, resgatável em USDC",
    port_max_withdraw_note: "Saque máximo permitido de 1%",
    port_rule_title_max_drawdown: "Drawdown máximo",
    port_rule_title_daily_loss: "Perda diária",
    port_rule_title_inactivity: "Regra de inatividade",
    port_rule_name_max_drawdown: "drawdown máximo",
    port_rule_name_daily_loss: "limite de perda diária",
    port_rule_name_inactivity: "regra de inatividade",
    port_and: "e",
    port_breach_desc_prefix: "Sua conta excedeu o",
    port_breach_desc_inactivity: "Sua conta violou a regra de inatividade.",
    port_breach_retry_left: "Você ainda tem mais uma nova tentativa grátis.",
    port_free_retry: "NOVA TENTATIVA GRÁTIS",
    port_prp_value: "VALOR DO PRP",
    port_breached: "violado",
    port_exhausted_title: "Suas tentativas gratuitas terminaram",
    port_exhausted_desc: "Você esgotou suas novas tentativas gratuitas.",
    port_exhausted_offer: "Você ainda pode ativar uma conta financiada instantaneamente por",
    port_promo_prefix: "Use o código",
    port_promo_suffix: "para ganhar 10% de desconto.",
    port_offer_title: "🎉 OFERTA DE PRIMEIRA ATIVAÇÃO",
    port_offer_desc: "Use {code} no checkout para ganhar 10% de desconto na sua primeira ativação.",
    port_offer_copy: "COPIAR CÓDIGO",
    port_offer_copied: "COPIADO",
    port_offer_remaining: "Restam {left} de {total} usuários",
    port_get_funded_for: "SEJA FINANCIADO POR",
    port_get_funded: "SEJA FINANCIADO",
    port_cycle_ended_title: "Ciclo de trading encerrado",
    port_cycle_ended_desc: "Sua conta excedeu os limites de drawdown máximo e de perda diária.",
    port_promo_new_account: "para ganhar 10% de desconto na sua nova conta.",
    port_get_funded_again: "SEJA FINANCIADO NOVAMENTE",
    port_previous_cycle: "CICLO ANTERIOR",
    port_drawdown_reached: "Drawdown atingido",
    port_daily_loss_reached: "Perda diária atingida",
    port_final_equity: "Equity final",
    port_what_we_offer: "O QUE OFERECEMOS",
    port_offer_free_title: "Comece grátis",
    port_offer_free_desc: "Pague só depois de atingir +1%.",
    port_offer_loss_title: "Perda máxima estática de 20%",
    port_offer_loss_desc: "Mais espaço para operar.",
    port_offer_share_title: "100% de divisão de lucros",
    port_offer_share_desc: "1 PRP = 0.50 USDC.",
    port_previous_payouts: "PAGAMENTOS ANTERIORES",
    port_view_all_payouts: "Ver todos os pagamentos",
    port_help_intro: "Nossa equipe está aqui se você precisar de algo.",
    port_redemption_note: "De {prp} PRP a uma taxa de resgate de {rate} USDC",
    port_erc20_label: "ENDEREÇO USDC ERC20",
    port_payout_review_note: "Aguarde 24 horas para a análise. Após a aprovação, sua nova conta MT5 será sincronizada.",
    acc_full_name: "Nome completo",
    acc_email: "E-mail",
    acc_save: "SALVAR",
    acc_saving: "SALVANDO…",
    acc_saved: "Salvo.",
    port_mt5_download: "Baixar MT5",
    menu_dark_mode: "Modo escuro",
    menu_join_discord: "ENTRE NA COMUNIDADE DO DISCORD",
    menu_logout: "SAIR",
  },

  FR: {
    nav_portfolio: "Portefeuille", nav_stats: "Statistiques", nav_leaderboard: "Classement", nav_referrals: "Parrainages", nav_account: "Compte", nav_help: "Centre d'aide",
    header_docs: "DOCS", header_support: "SUPPORT", header_switch_theme: "CHANGER THÈME", header_language: "Langue", header_edit_name: "Modifier le nom", header_save_change: "ENREGISTRER",
    footer_online: "EN LIGNE", footer_docs: "Docs", footer_support: "Support", footer_terms: "Conditions", footer_privacy: "Confidentialité",
    stats_title: "Statistiques",
    stats_subtitle: "Activité en direct de l'écosystème PropFunding.",
    stats_free_accounts: "COMPTES GRATUITS OUVERTS",
    stats_qualified: "TRADERS QUALIFIÉS",
    stats_activated: "COMPTES ACTIVÉS",
    stats_usdc_paid: "TOTAL USDC PAYÉ",
    stats_tip_free: "Comptes gratuits de 10 000 PRP ouverts à ce jour",
    stats_tip_qualified: "Traders ayant atteint l'objectif de 1 % et respecté toutes les autres règles de trading",
    stats_tip_activated: "Comptes activés après qualification",
    stats_tip_usdc_paid: "USDC versé aux traders à ce jour",
    stats_history_label: "HISTORIQUE",
    stats_qual_title: "Activité de qualification",
    stats_qual_desc: "Traders atteignant +1 % au fil du temps.",
    stats_fee_title: "Où vont vos frais d'activation",
    stats_fee_onetime: "FRAIS D'ACTIVATION UNIQUES",
    stats_fee_onetime_desc: "Payés uniquement après avoir atteint +1 %",
    stats_fee_badge: "Qualification gratuite",
    stats_fee_pool: "Pool de retraits",
    stats_fee_pool_desc: "Mis de côté avant le début des retraits",
    stats_fee_returned: "Restitué",
    stats_fee_returned_desc: "Votre +1 % est versé en USDC à l'activation",
    stats_fee_platform: "Plateforme",
    stats_fee_platform_desc: "Vérification, paiements et support",
    stats_fee_note: "Les revenus des comptes ne sont pas traités comme une seule enveloppe d'exploitation. Le capital est séparé pour soutenir la liquidité, la gestion de l'exposition et la pérennité à long terme.",
    stats_redemptions_label: "RACHATS",
    stats_redemptions_title: "USDC versé aux traders",
    stats_redemptions_desc: "Rachats de qualification et retraits standard.",
    stats_outcomes_label: "RÉSULTATS DES COMPTES",
    stats_breaches_title: "Dépassements",
    stats_breaches_desc: "Comptes ayant atteint une limite de perte.",
    stats_rules_label: "RÈGLES DE LA PLATEFORME",
    stats_rule_max_loss: "PERTE MAXIMALE",
    stats_rule_max_loss_desc: "Perte maximale statique depuis le solde initial.",
    stats_rule_daily: "LIMITE DE PERTE JOURNALIÈRE",
    stats_rule_daily_desc: "Perte journalière maximale des fonds propres.",
    stats_rule_withdraw: "LIMITE DE RETRAIT",
    stats_rule_withdraw_desc: "Maximum par période glissante de 28 jours.",
    stats_rule_rate: "TAUX DE RACHAT",
    stats_rule_rate_desc: "Fixe pour chaque rachat éligible.",
    stats_transparency_label: "TRANSPARENCE",
    stats_transparency_title: "Rien de caché",
    stats_transparency_desc: "Tout ce que vous devez savoir est visible avant de trader.",
    stats_target_title: "L'objectif",
    stats_target_desc: "+1 % pour se qualifier.",
    stats_rate_title: "Le taux",
    stats_rate_desc: "1 PRP = 0,50 USDC.",
    stats_limits_title: "Les limites",
    stats_limits_desc: "20 % de perte max statique, 5 % de perte journalière.",
    stats_cta_title: "Conçu pour financer les gagnants",
    stats_year_filter: "Filtrer par année",
    stats_loading: "Chargement des statistiques…",
    stats_load_error: "Impossible de charger les statistiques.",
    stats_no_data: "Pas encore de données.",
    stats_no_payouts: "Aucun paiement pour l'instant.",

    stats_section_overview: "VUE D'ENSEMBLE DE LA PLATEFORME",






    stats_daily_dd_breach: "Infraction DD quotidien", stats_max_dd_breach: "Infraction DD maximum",





    lb_active_traders: "TRADERS ACTIFS",
    lb_qualified_traders: "TRADERS QUALIFIÉS",
    lb_total_prp: "PRP TOTAL",
    lb_total_usdc_paid: "TOTAL USDC PAYÉ",
    lb_usdc_paid: "USDC PAYÉ",
    lb_tip_active: "Traders avec un compte ouvert ce cycle",
    lb_tip_qualified: "Traders ayant atteint l'objectif de 1 % et respecté toutes les autres règles de trading",
    lb_tip_total_prp: "Équité combinée des comptes PRP de tous les traders actifs.",
    lb_tip_usdc_paid: "USDC versé aux traders à ce jour",
    lb_tip_prp_profit: "C'est le total cumulé de PRP qu'ils ont gagné.",
    lb_no_results: "Aucun résultat pour « {query} »",
    lb_loading: "Chargement du classement…",
    lb_load_error: "Impossible de charger le classement.",
    lb_empty: "Aucun trader au classement pour le moment.",
    lb_you: "vous",
    lb_cta_title: "Prêt à rejoindre le",
    lb_cta_highlight: "classement ?",
    lb_cta_desc: "Aucun frais initial, aucune règle de constance et une valeur fixe en USDC pour chaque PRP éligible gagné.",
    lb_cta_desc_mobile: "Commencez gratuitement avec un compte de 10 000 PRP et prouvez votre avantage.",
    lb_cta_btn: "COMMENCER GRATUITEMENT",
    share_text_line2: "Commencez à trader gratuitement avec Propfunding.com",
    lb_title: "Classement", lb_live: "EN DIRECT", lb_live_update: "Mis à jour toutes les 5 minutes", lb_your_position: "VOTRE POSITION", lb_share: "PARTAGER", lb_traders: "Traders", lb_search: "Rechercher des traders",
    lb_rank: "RANG", lb_name: "NOM", lb_prop_profit: "PROFIT PRP", lb_status: "STATUT", lb_usdc_payouts: "PAIEMENTS USDC", lb_daily_dd: "DD QUOTIDIEN", lb_max_dd: "DD MAXIMUM",
    lb_status_active: "ACTIF", lb_status_critical: "CRITIQUE", lb_status_breached: "INFRACTION",
    lb_pool_balance: "SOLDE DU POOL", lb_funded_traders: "TRADERS FINANCÉS", lb_total_profit: "PROFIT TOTAL EN $PROP", lb_total_payouts: "TOTAL PAIEMENTS USDC",
    lb_detail_week: "$8 400 cette semaine", lb_detail_month: "-12 ce mois", lb_detail_across: "Sur tous les comptes financés", lb_detail_5k_cycle: "$5 000 dernier cycle",
    ref_title: "Parrainages", ref_copy: "Gagnez 25 $ sur les frais d'activation de chaque trader parrainé.",
    ref_enter_code: "ENTRER UN CODE", ref_share_link: "PARTAGER LE LIEN", ref_withdraw: "RETIRER LA RÉCOMPENSE",
    ref_traders_referred: "TRADERS PARRAINÉS", ref_rewards_earned: "RÉCOMPENSES GAGNÉES", ref_withdrawable: "RÉCOMPENSE RETIRABLE", ref_min_required: "125 $ minimum requis",
    ref_history: "Historique des parrainages", ref_email: "EMAIL", ref_date_joined: "DATE D'INSCRIPTION", ref_fee_paid: "FRAIS PAYÉS", ref_your_reward: "VOTRE RÉCOMPENSE",
    ref_modal_share_title: "Partagez votre lien de parrainage",
    ref_copy_btn: "COPIER", ref_copied_btn: "COPIÉ",
    ref_modal_code_title: "Entrer un code de parrainage",
    ref_code_placeholder: "Coller le code ou le lien de parrainage",
    ref_stepper_request: "DEMANDE", ref_stepper_review: "VÉRIFIER", ref_stepper_wallet: "PORTEFEUILLE",
    ref_withdraw_title: "Retirer la récompense",
    ref_withdrawable_label: "RETIRABLE",
    ref_amount_label: "Montant à retirer",
    ref_max_prefix: "MAX :",
    ref_min_text: "125 $ minimum requis",
    ref_wallet_label: "Adresse ERC20 USDC",
    ref_continue_btn: "CONTINUER",
    ref_review_title: "Vérifier la demande",
    ref_erc20_label: "ADRESSE ERC-20",
    ref_amount_field: "MONTANT",
    ref_currency_label: "DEVISE",
    ref_processing_label: "TRAITEMENT",
    ref_processing_time: "24H (WEEK-ENDS EXCLUS)",
    ref_confirm_btn: "CONFIRMER LE RETRAIT",
    ref_back_btn: "RETOUR",
    ref_success_title: "Retrait soumis",
    ref_success_subtitle: "Votre USDC est en route. Il arrive généralement dans les 24 heures.",
    ref_reference_label: "RÉFÉRENCE",
    ref_email_sent: "Nous vous enverrons un e-mail dès son envoi",
    port_title: "Portefeuille", port_waiting_account: "Il n'y a plus de comptes de trading disponibles pour le moment. Vous êtes dans la file : nous vous en attribuerons un automatiquement et vous enverrons un e-mail dès qu'un compte sera libre, même si vous fermez cette page.", port_overview: "VUE D'ENSEMBLE", port_balance: "SOLDE", port_profit_loss: "PROFIT/PERTE", port_drawdown: "DRAWDOWN", port_rank: "RANG", port_share: "PARTAGER",
    port_trading_obj: "OBJECTIFS DE TRADING", port_in_range: "DANS LA LIMITE",
    port_max_drawdown: "DRAWDOWN MAXIMUM", port_of_initial: "du solde initial",
    port_daily_loss: "LIMITE DE PERTE QUOTIDIENNE", port_of_starting: "du solde de début de journée",
    port_monthly_profit: "PROFIT MENSUEL MAXIMUM",
    port_withdrawal_hist: "HISTORIQUE DES RETRAITS", port_date: "DATE", port_payout_amount: "MONTANT DU PAIEMENT", port_status: "STATUT", port_tx_id: "ID DE TRANSACTION", port_completed: "COMPLÉTÉ", port_view_all: "Voir tous les retraits",
    port_account_details: "DÉTAILS DU COMPTE", port_login: "IDENTIFIANT", port_master_pw: "MOT DE PASSE MAÎTRE", port_investor_pw: "MOT DE PASSE INVESTISSEUR", port_mt5_server: "SERVEUR MT5", port_next_payout: "PROCHAINE ADMISSIBILITÉ AU PAIEMENT", port_request_payout: "DEMANDER UN PAIEMENT",
    port_prop_value: "VALEUR PROP", port_current_value: "VALEUR ACTUELLE", port_usdc_per_prop: "USDC par $PROP", port_30d_change: "VARIATION 30J",
    port_help_center: "CENTRE D'AIDE", port_docs: "DOCS", port_discord: "DISCORD",
    port_show_pw: "Afficher le mot de passe", port_hide_pw: "Masquer le mot de passe",
    port_activate_title: "Activez votre compte prop de 10 000",
    port_one_time_fee: "Frais uniques",
    port_profit_share: "100% de partage des profits",
    port_about_title: "À propos de PropFunding",
    port_no_consistency: "Aucune règle de cohérence",
    port_no_min_days: "Levier 1:10 disponible",
    port_biweekly: "Retraits bimensuels",
    port_zero_comms: "$0 de commissions et spreads bruts",
    port_forex_available: "Tradez les forex majeurs, mineurs et or",
    port_platform_stats: "STATISTIQUES DE LA PLATEFORME",
    port_total_funded_stat: "TOTAL DES TRADERS FINANCÉS",
    port_pool_balance_stat: "SOLDE DU POOL",
    port_total_payouts_stat: "TOTAL DES PAIEMENTS USDC",
    port_prop_value_stat_label: "VALEUR $PROP",
    port_stat_week: "+23 cette semaine",
    port_stat_backed: "Soutenu par du capital réel",
    port_stat_this_week: "Cette semaine",
    port_stat_7d: "+2.41% (7J)",
    port_real_payouts_title: "VRAIS TRADERS ET VRAIS PAIEMENTS",
    port_payout_modal_title: "Demander un paiement",
    port_available_withdraw: "DISPONIBLE AU RETRAIT",
    port_prop_amount_label: "Montant à retirer en $PROP",
    port_prop_min_error: "Minimum de {min} requis",
    port_prop_max_error: "Dépasse le solde disponible",
    port_prop_min_placeholder: "Min. {min}",
    port_payout_min_tooltip: "Montant minimum de retrait : {min} PRP (2 % de la taille de votre compte).",
    port_prop_min_note: "Retrait minimum de 2% requis",
    port_you_receive: "VOUS RECEVEZ",
    port_paste_address: "Coller l'adresse",
    port_payout_request_label: "DEMANDE DE PAIEMENT",
    port_payout_rate_label: "TAUX",
    port_usdc_redeemed_label: "USDC ÉCHANGÉ",
    port_processing_fee_label: "FRAIS DE TRAITEMENT",
    port_net_payout_label: "PAIEMENT NET",
    port_confirm_payout_btn: "CONFIRMER LE PAIEMENT",
    port_payout_submitted_title: "Demande de paiement soumise",
    port_payout_submitted_subtitle: "Notre équipe examinera votre demande. Les mises à jour sont généralement fournies dans les 24 heures.",
    footer_cta_title: "Commencez à trader avec le", footer_cta_highlight: "nouveau modèle",
    footer_cta_desc: "Rejoignez un système où la performance, et non la plateforme, détermine les résultats.",
    footer_cta_btn: "OBTENIR DES FONDS",
    share_modal_title: "Partager la position au classement",
    share_position_label: "Classement\nposition",
    share_prop_profit: "PROFIT PRP", share_usdc_payouts: "PAIEMENTS USDC", share_referral_code: "CODE DE PARRAINAGE",
    share_default_text: "Je suis #{rank}e au Classement PropFunding 🏆",
    share_field_referral: "Code de parrainage", share_field_text: "Personnalisez votre texte",
    share_overlay: "Superposition", share_overlay_none: "Sans superposition", share_overlay_bull: "Superposition haussière", share_overlay_bear: "Superposition baissière",
    share_save: "ENREGISTRER L'IMAGE", share_copy_link: "COPIER LE LIEN", share_on: "PARTAGER SUR",
    checkout_title: "Acheter un compte financé",
    checkout_payment_method: "Méthode de paiement",
    checkout_card: "Carte de crédit/débit", checkout_card_soon: "Carte de crédit/débit (Bientôt disponible)", checkout_crypto: "Crypto (USDC/USDT)",
    checkout_discount: "Code de réduction", checkout_apply: "APPLIQUER",
    checkout_summary: "Récapitulatif", checkout_account: "Compte Prop 10K$",
    checkout_discount_line: "Réduction", checkout_total: "TOTAL",
 checkout_card_number: "Numéro de carte", checkout_expiry: "Expiration", checkout_cvv: "CVV", checkout_complete: "TERMINER", checkout_billing: "Informations de facturation", checkout_card_whop_text: "Vous saisirez vos informations de carte en toute sécurité à l'étape suivante.", checkout_crypto_whop_text: "Vous serez redirigé pour payer en USDC ou USDT. Choisissez votre réseau sur la page de paiement et envoyez uniquement sur ce réseau.", checkout_confirming: "Confirmation de votre paiement…", checkout_processing: "Votre paiement est en cours de traitement. Votre compte sera activé dès sa confirmation.", checkout_back_portfolio: "RETOUR AU PORTEFEUILLE",
    cs_title: "Statut du paiement", cs_loading: "Chargement de votre paiement…", cs_not_found: "Impossible de charger ce paiement.", cs_awaiting: "En attente de paiement", cs_awaiting_desc: "Terminez le paiement sur la page de paiement. Cette page se met à jour automatiquement.", cs_confirming: "Confirmation en cours", cs_confirming_desc: "Votre paiement est sur la blockchain. Nous attendons sa confirmation.", cs_partially_paid: "Partiellement payé", cs_partially_paid_desc: "Nous avons reçu une partie de votre paiement. Envoyez le montant restant depuis la page de paiement.", cs_paid: "Payé", cs_paid_activation: "Paiement reçu. Votre compte est activé.", cs_expired: "Expiré", cs_expired_desc: "Cette demande de paiement a expiré. Si vous avez déjà envoyé des fonds, contactez le support. Sinon, lancez un nouveau paiement.", cs_needs_review: "En cours d'examen", cs_needs_review_desc: "Nous avons reçu votre paiement et notre équipe l'examine. Nous vous contacterons rapidement.", cs_amount_due: "Montant dû", cs_paid_so_far: "Déjà payé", cs_open_widget: "OUVRIR LA PAGE DE PAIEMENT", cs_network_warning: "Envoyez uniquement des USDC ou USDT, et uniquement sur le réseau choisi sur la page de paiement. Les dépôts envoyés sur un autre réseau seront perdus.",
    checkout_funded_received: "Paiement reçu. Nous configurons votre compte financé ; il apparaîtra dans votre portefeuille dès qu'il sera prêt.",


    port_tooltip_withdraw: "Montant maximum éligible au retrait basé sur le bénéfice net de votre compte MT5, net des frais de traitement applicables",
    port_tooltip_max_drawdown: "La perte maximale statique basée sur votre solde de départ. Si vos fonds propres atteignent ce niveau, le compte est automatiquement désactivé",
    port_tooltip_daily_loss: "La perte maximale de capitaux propres autorisée en une seule journée de trading. La limite de perte journalière inclut les positions ouvertes et fermées",
    port_tooltip_monthly_profit: "Le profit maximum que vous pouvez retirer en un mois calendaire. Se réinitialise le 1er de chaque mois",
    port_tooltip_balance: "Votre solde total de compte réglé en PRP après les transactions fermées",
    port_tooltip_profit_loss: "Votre profit ou perte réalisé(e) sur les transactions terminées",
    port_tooltip_drawdown: "Votre drawdown actuel basé sur les positions perdantes actives et fermées",
    port_tooltip_rank: "Votre classement parmi les traders actifs de PropFunding",
    port_tooltip_prop_value: "Les profits PRP éligibles sont convertis à ce taux fixe lors du retrait",
    // Strings added after the first translation pass
    ref_payout_date: "DATE DE PAIEMENT",
    ref_status: "STATUT",
    ref_tab_all: "Tous",
    ref_tab_claimed: "Réclamés",
    ref_status_trial: "Essai",
    ref_status_activated: "Activé",
    ref_status_claimed: "Réclamé",
    ref_no_claimed: "Aucune récompense réclamée pour le moment.",
    ref_no_referrals: "Aucun parrainage pour le moment. Partagez votre lien pour commencer à gagner.",
    ref_loading: "Chargement de vos parrainages…",
    ref_load_error: "Impossible de charger vos parrainages.",
    ref_retry: "RÉESSAYER",
    ref_using_code: "Vous utilisez le code : {code}",
    share_saving: "ENREGISTREMENT…",
    share_loading: "Chargement de l'image",
    share_discord_copied: "Publication copiée. Collez-la dans Discord.",
    share_failed: "Cela n'a pas fonctionné. Veuillez réessayer.",
    help_title: "Centre d'aide",
    help_subtitle: "Obtenez de l'aide pour votre compte et suivez vos demandes d'assistance.",
    help_report_issue: "Signaler un problème",
    help_report_issue_title: "Signaler un problème",
    help_search_placeholder: "Rechercher dans les articles d'aide",
    help_support_tickets: "Tickets d'assistance",
    help_tab_open: "Ouverts",
    help_tab_resolved: "Résolus",
    help_issue: "Problème",
    help_category: "Catégorie",
    help_submitted: "Envoyé",
    help_status: "Statut",
    help_action: "Action",
    help_status_in_progress: "En cours",
    help_status_resolved: "Résolu",
    help_see_details: "Voir les détails",
    help_manage: "Gérer",
    help_no_tickets: "Aucun ticket ici.",
    help_faq: "FAQ",
    help_articles: "articles",
    help_popular_articles: "Articles populaires",
    help_no_results: "Aucun article ne correspond à votre recherche.",
    help_ticket_details: "Détails du ticket",
    help_ticket_id: "ID du ticket",
    help_description: "Description",
    help_attachment: "Pièce jointe",
    help_original_message: "Message d'origine",
    help_additional_detail: "Précision supplémentaire",
    help_original_attachment: "Pièce jointe d'origine",
    help_additional_attachment: "Pièce jointe supplémentaire",
    help_need_more_info: "Besoin d'ajouter des informations ?",
    help_add_details_placeholder: "Ajoutez des détails...",
    help_upload_screenshot: "Téléverser une capture d'écran",
    help_add_update: "Ajouter une mise à jour",
    help_status_sent: "Envoyé",
    help_select_category: "Sélectionnez une catégorie",
    help_issue_description: "Description du problème",
    help_issue_description_hint: "Veuillez décrire le problème en détail.",
    help_describe_placeholder: "Décrivez le problème que vous rencontrez...",
    help_attachment_optional: "Pièce jointe (facultatif)",
    help_attachment_hint: "Téléversez une capture d'écran pour nous aider à comprendre le problème plus rapidement.",
    help_upload_or_drag: "Téléversez ou glissez un fichier",
    help_cancel: "Annuler",
    help_submit_issue: "Envoyer le problème",
    help_issue_reported: "Problème signalé",
    help_issue_reported_note: "Votre problème a bien été signalé. Surveillez la section du centre d'aide pour les mises à jour.",
    help_report_another: "En signaler un autre",
    help_done: "Terminé",
    help_report_category_issue: "Signaler un problème : {category}",
    help_articles_title: "Articles",
    help_team_reply: "Réponse de l'équipe support", help_loading: "Chargement…", help_sending: "Envoi…", help_tickets_error: "Nous n'avons pas pu charger vos tickets.", help_try_again: "Réessayer",
    port_free_title: "Entrée gratuite. Un seul objectif.",
    port_free_desc: "Atteignez +1 % sur votre compte de 10,000 PRP pour être éligible à l'activation.",
    port_start_trading: "COMMENCER À TRADER",
    port_getting_ready: "Préparation de votre compte...",
    port_free_accounts_stat: "COMPTES GRATUITS OUVERTS",
    port_qualified_stat: "TRADERS QUALIFIÉS",
    port_activated_stat: "COMPTES ACTIVÉS",
    port_total_paid_stat: "TOTAL USDC VERSÉ",
    port_tooltip_free_accounts: "Nombre total de comptes gratuits de 10,000 PRP ouverts sur PropFunding",
    port_tooltip_qualified: "Traders ayant atteint l'objectif de qualification de +1 %",
    port_tooltip_activated: "Comptes qualifiés ayant payé les frais d'activation et finalisé le KYC",
    port_tooltip_total_paid: "Total des USDC versés aux traders PropFunding",
    port_inactivity: "INACTIVITÉ",
    port_tooltip_inactivity: "Vous devez trader au moins une fois tous les 14 jours, sinon votre compte sera désactivé",
    port_qualifying_target: "OBJECTIF DE QUALIFICATION",
    port_tooltip_qualifying: "Faites croître votre compte de 10,000 PRP de 1 % pour être éligible à l'activation",
    port_min_trading_days: "JOURS DE TRADING MINIMUM",
    port_tooltip_min_days: "Votre compte doit compter au moins 3 jours de trading pour se qualifier",
    port_achieved: "atteint",
    port_reached: "atteint",
    port_days: "jours",
    port_process: "LE PROCESSUS",
    port_how_it: "Comment ça",
    port_works: "marche",
    port_step1_title: "Commencez gratuitement",
    port_step1_desc: "Commencez à trader votre compte de 10,000 PRP sans frais initiaux.",
    port_step2_title: "Atteignez +1 %",
    port_step2_desc: "Faites croître votre compte de 1 % pour vous qualifier. Les comptes doivent compter au moins 3 jours de trading pour se qualifier.",
    port_step3_title: "Activez et vérifiez",
    port_step3_desc: "Payez les frais d'activation sous 48 heures et finalisez votre KYC.",
    port_step4_title: "Échangez en USDC",
    port_step4_desc: "Retirez votre profit de qualification de +1 % en USDC à l'activation. Votre compte est réinitialisé et les retraits standard commencent après 14 jours.",
    port_mt5_account_details: "DÉTAILS DU COMPTE MT5",
    port_usdc_per_prp: "USDC par PRP",
    port_hit_target: "Vous avez atteint 1 %.",
    port_time_to_activate: "Il est temps d'activer.",
    port_activate_desc: "Activez sous 48 heures pour débloquer votre compte financé et retirer votre profit de qualification de 1 %.",
    port_activate_soon: "Activez vite –",
    port_time_running_out: "le temps presse",
    port_activate_urgent_desc: "Vous risquez de perdre votre compte financé. Payez les frais d'activation sous 24 heures pour l'éviter.",
    port_window_title: "Délai d'activation",
    port_window_expired: "expiré",
    port_window_expired_desc: "Votre délai d'activation de 48 heures a expiré. Cette qualification ne peut plus être activée.",
    port_qualification_result: "RÉSULTAT DE QUALIFICATION",
    port_qualification_reached: "+1 % atteint",
    port_qualification_redemption: "ÉCHANGE DE QUALIFICATION",
    port_expired_value: "Expiré",
    port_activation_status: "STATUT D'ACTIVATION",
    port_expired_status: "EXPIRÉ",
    port_expired_on: "Expiré le {date} à {time}",
    port_start_next_attempt: "LANCER LA PROCHAINE TENTATIVE GRATUITE",
    port_activation_fee: "FRAIS D'ACTIVATION",
    port_redeem_after_activation: "ÉCHANGE DISPONIBLE APRÈS ACTIVATION",
    port_redeem_after_activation_short: "ÉCHANGE APRÈS ACTIVATION",
    port_time_left: "TEMPS RESTANT POUR ACTIVER",
    port_hours: "heures",
    port_minutes: "minutes",
    port_seconds: "secondes",
    port_activate_short: "ACTIVER",
    checkout_claim_title: "Payez pour obtenir votre compte financé",
    checkout_card_with_fee: "Carte de crédit/débit (frais de traitement de 2,9 %)",
    checkout_card_with_fee_short: "Carte de crédit/débit (frais de 2,9 %)",
    checkout_activation_account: "Compte Prop de 10K $",
    checkout_card_fee: "Frais de traitement par carte",
    checkout_crypto_plain: "Crypto",
    port_next_steps: "PROCHAINES ÉTAPES",
    port_pending: "EN ATTENTE",
    port_next_verify_title: "Vérifiez votre identité",
    port_next_verify_desc: "Vérification KYC rapide pour débloquer les paiements.",
    port_next_withdraw_title: "Retirez vos 1 %",
    port_next_withdraw_desc: "Votre récompense pour avoir atteint l'objectif de qualification.",
    port_next_trade_title: "Continuez à trader",
    port_next_trade_desc: "Visez le prochain palier sur le marché.",
    port_kyc_title: "VÉRIFICATION KYC",
    port_kyc_required: "DOCUMENTS REQUIS",
    port_kyc_doc_id: "Pièce d'identité (passeport, permis de conduire, carte d'identité officielle).",
    port_kyc_doc_address: "Justificatif de domicile (facture de services, facture de téléphone, relevé bancaire).",
    port_kyc_start: "LANCER LA VÉRIFICATION D'IDENTITÉ",
    port_kyc_error: "ERREUR DE VÉRIFICATION",
    port_kyc_error_desc: "Nous n'avons pas pu vérifier votre identité.",
    port_kyc_try_again: "RÉESSAYER",
    port_kyc_contact_support: "Contacter le support",
    port_kyc_pending: "EN COURS D'EXAMEN",
    port_kyc_pending_desc: "Nous examinons vos documents. Cela prend généralement quelques minutes ; nous mettrons cette carte à jour une fois terminé.",
    port_kyc_rejected_desc: "Nous n'avons pas pu vérifier votre identité et cette vérification ne peut pas être relancée. Veuillez contacter le support.",
    port_kyc_loading: "Lancement de la vérification...",
    port_withdraw_profit: "RETIRER LE PROFIT",
    port_to_withdraw: "À RETIRER",
    port_tooltip_to_withdraw: "Votre profit de qualification de +1 %, échangeable en USDC",
    port_max_withdraw_note: "Retrait maximum autorisé de 1 %",
    port_rule_title_max_drawdown: "Drawdown maximum",
    port_rule_title_daily_loss: "Perte journalière",
    port_rule_title_inactivity: "Règle d'inactivité",
    port_rule_name_max_drawdown: "drawdown maximum",
    port_rule_name_daily_loss: "limite de perte journalière",
    port_rule_name_inactivity: "règle d'inactivité",
    port_and: "et",
    port_breach_desc_prefix: "Votre compte a dépassé la",
    port_breach_desc_inactivity: "Votre compte a enfreint la règle d'inactivité.",
    port_breach_retry_left: "Il vous reste encore une nouvelle tentative gratuite.",
    port_free_retry: "NOUVELLE TENTATIVE GRATUITE",
    port_prp_value: "VALEUR DU PRP",
    port_breached: "enfreint",
    port_exhausted_title: "Vos tentatives gratuites sont terminées",
    port_exhausted_desc: "Vous avez épuisé vos nouvelles tentatives gratuites.",
    port_exhausted_offer: "Vous pouvez toujours activer un compte financé instantanément pour",
    port_promo_prefix: "Utilisez le code",
    port_promo_suffix: "pour obtenir 10 % de réduction.",
    port_offer_title: "🎉 OFFRE DE PREMIÈRE ACTIVATION",
    port_offer_desc: "Utilisez {code} au paiement pour obtenir 10 % de réduction sur votre première activation.",
    port_offer_copy: "COPIER LE CODE",
    port_offer_copied: "COPIÉ",
    port_offer_remaining: "{left} utilisateurs restants sur {total}",
    port_get_funded_for: "OBTENEZ UN FINANCEMENT POUR",
    port_get_funded: "OBTENEZ UN FINANCEMENT",
    port_cycle_ended_title: "Cycle de trading terminé",
    port_cycle_ended_desc: "Votre compte a dépassé les limites de drawdown maximum et de perte journalière.",
    port_promo_new_account: "pour obtenir 10 % de réduction sur votre nouveau compte.",
    port_get_funded_again: "OBTENEZ UN NOUVEAU FINANCEMENT",
    port_previous_cycle: "CYCLE PRÉCÉDENT",
    port_drawdown_reached: "Drawdown atteint",
    port_daily_loss_reached: "Perte journalière atteinte",
    port_final_equity: "Equity finale",
    port_what_we_offer: "CE QUE NOUS OFFRONS",
    port_offer_free_title: "Commencez gratuitement",
    port_offer_free_desc: "Ne payez qu'après avoir atteint +1 %.",
    port_offer_loss_title: "Perte maximale statique de 20 %",
    port_offer_loss_desc: "Plus de marge pour trader.",
    port_offer_share_title: "100 % de partage des profits",
    port_offer_share_desc: "1 PRP = 0.50 USDC.",
    port_previous_payouts: "PAIEMENTS PRÉCÉDENTS",
    port_view_all_payouts: "Voir tous les paiements",
    port_help_intro: "Notre équipe est là si vous avez besoin de quoi que ce soit.",
    port_redemption_note: "À partir de {prp} PRP à un taux d'échange de {rate} USDC",
    port_erc20_label: "ADRESSE USDC ERC20",
    port_payout_review_note: "Veuillez prévoir 24 heures pour l'examen. Une fois approuvé, votre nouveau compte MT5 sera synchronisé.",
    acc_full_name: "Nom complet",
    acc_email: "E-mail",
    acc_save: "ENREGISTRER",
    acc_saving: "ENREGISTREMENT…",
    acc_saved: "Enregistré.",
    port_mt5_download: "Télécharger MT5",
    menu_dark_mode: "Mode sombre",
    menu_join_discord: "REJOINDRE LA COMMUNAUTÉ DISCORD",
    menu_logout: "SE DÉCONNECTER",
  },

  AR: {
    nav_portfolio: "المحفظة", nav_stats: "الإحصائيات", nav_leaderboard: "لوحة المتصدرين", nav_referrals: "الإحالات", nav_account: "الحساب", nav_help: "مركز المساعدة",
    header_docs: "المستندات", header_support: "الدعم", header_switch_theme: "تبديل السمة", header_language: "اللغة", header_edit_name: "تعديل الاسم", header_save_change: "حفظ التغيير",
    footer_online: "متصل", footer_docs: "المستندات", footer_support: "الدعم", footer_terms: "الشروط", footer_privacy: "الخصوصية",
    stats_title: "الإحصائيات",
    stats_subtitle: "نشاط مباشر عبر منظومة PropFunding.",
    stats_free_accounts: "الحسابات المجانية المفتوحة",
    stats_qualified: "المتداولون المؤهلون",
    stats_activated: "الحسابات المفعّلة",
    stats_usdc_paid: "إجمالي USDC المدفوع",
    stats_tip_free: "حسابات مجانية بقيمة 10,000 PRP فُتحت حتى الآن",
    stats_tip_qualified: "المتداولون الذين حققوا هدف 1% والتزموا بجميع قواعد التداول الأخرى",
    stats_tip_activated: "الحسابات المفعّلة بعد التأهل",
    stats_tip_usdc_paid: "USDC المدفوع للمتداولين حتى الآن",
    stats_history_label: "السجل",
    stats_qual_title: "نشاط التأهل",
    stats_qual_desc: "المتداولون الذين يحققون +1% بمرور الوقت.",
    stats_fee_title: "أين تذهب رسوم التفعيل",
    stats_fee_onetime: "رسوم تفعيل لمرة واحدة",
    stats_fee_onetime_desc: "تُدفع فقط بعد أن تحقق +1%",
    stats_fee_badge: "التأهل مجاني",
    stats_fee_pool: "صندوق السحب",
    stats_fee_pool_desc: "يُخصَّص قبل بدء عمليات السحب",
    stats_fee_returned: "يُعاد إليك",
    stats_fee_returned_desc: "يُدفع لك +1% بعملة USDC عند التفعيل",
    stats_fee_platform: "المنصة",
    stats_fee_platform_desc: "التحقق والمدفوعات والدعم",
    stats_fee_note: "لا تُعامَل إيرادات الحسابات كوعاء تشغيلي واحد. يُفصل رأس المال لدعم السيولة وإدارة التعرض والاستدامة على المدى الطويل.",
    stats_redemptions_label: "عمليات الاسترداد",
    stats_redemptions_title: "USDC المدفوع للمتداولين",
    stats_redemptions_desc: "استردادات التأهل وعمليات السحب القياسية.",
    stats_outcomes_label: "نتائج الحسابات",
    stats_breaches_title: "المخالفات",
    stats_breaches_desc: "الحسابات التي بلغت حد الخسارة.",
    stats_rules_label: "قواعد المنصة",
    stats_rule_max_loss: "الحد الأقصى للخسارة",
    stats_rule_max_loss_desc: "حد خسارة ثابت من الرصيد الابتدائي.",
    stats_rule_daily: "حد الخسارة اليومية",
    stats_rule_daily_desc: "الحد الأقصى للخسارة اليومية في رأس المال.",
    stats_rule_withdraw: "حد السحب",
    stats_rule_withdraw_desc: "الحد الأقصى لكل 28 يومًا متتاليًا.",
    stats_rule_rate: "معدل الاسترداد",
    stats_rule_rate_desc: "ثابت في كل عملية استرداد مؤهلة.",
    stats_transparency_label: "الشفافية",
    stats_transparency_title: "لا شيء مخفي",
    stats_transparency_desc: "كل ما تحتاج معرفته واضح قبل أن تتداول.",
    stats_target_title: "الهدف",
    stats_target_desc: "+1% للتأهل.",
    stats_rate_title: "المعدل",
    stats_rate_desc: "1 PRP = 0.50 USDC.",
    stats_limits_title: "الحدود",
    stats_limits_desc: "خسارة قصوى ثابتة 20%، وحد خسارة يومية 5%.",
    stats_cta_title: "مصمم لتمويل الفائزين",
    stats_year_filter: "التصفية حسب السنة",
    stats_loading: "جارٍ تحميل الإحصائيات…",
    stats_load_error: "تعذّر تحميل الإحصائيات.",
    stats_no_data: "لا توجد بيانات بعد.",
    stats_no_payouts: "لا توجد مدفوعات بعد.",

    stats_section_overview: "نظرة عامة على المنصة",






    stats_daily_dd_breach: "انتهاك DD اليومي", stats_max_dd_breach: "انتهاك DD الأقصى",





    lb_active_traders: "المتداولون النشطون",
    lb_qualified_traders: "المتداولون المؤهلون",
    lb_total_prp: "إجمالي PRP",
    lb_total_usdc_paid: "إجمالي USDC المدفوع",
    lb_usdc_paid: "USDC المدفوع",
    lb_tip_active: "المتداولون الذين لديهم حساب مفتوح في هذه الدورة",
    lb_tip_qualified: "المتداولون الذين حققوا هدف 1% والتزموا بجميع قواعد التداول الأخرى",
    lb_tip_total_prp: "إجمالي حقوق ملكية حسابات PRP لجميع المتداولين النشطين.",
    lb_tip_usdc_paid: "USDC المدفوع للمتداولين حتى الآن",
    lb_tip_prp_profit: "إجمالي PRP التراكمي الذي حققوه.",
    lb_no_results: "لا توجد نتائج لـ “{query}”",
    lb_loading: "جارٍ تحميل لوحة المتصدرين…",
    lb_load_error: "تعذّر تحميل لوحة المتصدرين.",
    lb_empty: "لا يوجد متداولون في اللوحة بعد.",
    lb_you: "أنت",
    lb_cta_title: "هل أنت مستعد للانضمام إلى",
    lb_cta_highlight: "لوحة المتصدرين؟",
    lb_cta_desc: "بدون رسوم مسبقة، وبدون قاعدة اتساق، وقيمة ثابتة بالـ USDC لكل PRP مؤهل تكسبه.",
    lb_cta_desc_mobile: "ابدأ مجانًا بحساب 10,000 PRP وأثبت مهارتك.",
    lb_cta_btn: "ابدأ مجانًا",
    share_text_line2: "ابدأ التداول مجانًا مع Propfunding.com",
    lb_title: "لوحة المتصدرين", lb_live: "مباشر", lb_live_update: "يتحدث كل 5 دقائق", lb_your_position: "مرتبتك", lb_share: "مشاركة", lb_traders: "المتداولون", lb_search: "البحث عن متداولين",
    lb_rank: "الترتيب", lb_name: "الاسم", lb_prop_profit: "ربح PRP", lb_status: "الحالة", lb_usdc_payouts: "مدفوعات USDC", lb_daily_dd: "DD اليومي", lb_max_dd: "DD الأقصى",
    lb_status_active: "نشط", lb_status_critical: "حرج", lb_status_breached: "منتهك",
    lb_pool_balance: "رصيد المجمع", lb_funded_traders: "المتداولون الممولون", lb_total_profit: "إجمالي الربح بـ $PROP", lb_total_payouts: "إجمالي مدفوعات USDC",
    lb_detail_week: "$8,400 هذا الأسبوع", lb_detail_month: "-12 هذا الشهر", lb_detail_across: "عبر جميع الحسابات الممولة", lb_detail_5k_cycle: "$5,000 الدورة الماضية",
    ref_title: "الإحالات", ref_copy: "اكسب 25$ من رسوم تفعيل كل متداول تحيله.",
    ref_enter_code: "إدخال الرمز", ref_share_link: "مشاركة الرابط", ref_withdraw: "سحب المكافأة",
    ref_traders_referred: "المتداولون المُحالون", ref_rewards_earned: "المكافآت المكتسبة", ref_withdrawable: "المكافأة القابلة للسحب", ref_min_required: "الحد الأدنى $125 مطلوب",
    ref_history: "سجل الإحالات", ref_email: "البريد الإلكتروني", ref_date_joined: "تاريخ الانضمام", ref_fee_paid: "الرسوم المدفوعة", ref_your_reward: "مكافأتك",
    ref_modal_share_title: "شارك رابط إحالتك",
    ref_copy_btn: "نسخ", ref_copied_btn: "تم النسخ",
    ref_modal_code_title: "أدخل رمز الإحالة",
    ref_code_placeholder: "الصق رمز أو رابط الإحالة",
    ref_stepper_request: "الطلب", ref_stepper_review: "المراجعة", ref_stepper_wallet: "المحفظة",
    ref_withdraw_title: "سحب المكافأة",
    ref_withdrawable_label: "قابل للسحب",
    ref_amount_label: "المبلغ المراد سحبه",
    ref_max_prefix: "الحد الأقصى:",
    ref_min_text: "الحد الأدنى $125 مطلوب",
    ref_wallet_label: "عنوان ERC20 USDC",
    ref_continue_btn: "متابعة",
    ref_review_title: "مراجعة الطلب",
    ref_erc20_label: "عنوان ERC-20",
    ref_amount_field: "المبلغ",
    ref_currency_label: "العملة",
    ref_processing_label: "المعالجة",
    ref_processing_time: "24 ساعة (باستثناء عطلات نهاية الأسبوع)",
    ref_confirm_btn: "تأكيد السحب",
    ref_back_btn: "رجوع",
    ref_success_title: "تم تقديم السحب",
    ref_success_subtitle: "USDC الخاص بك في الطريق. يصل عادةً في غضون 24 ساعة.",
    ref_reference_label: "المرجع",
    ref_email_sent: "سنرسل لك بريدًا إلكترونيًا فور إرساله",
    port_title: "المحفظة", port_waiting_account: "لا توجد حسابات تداول متاحة حاليًا. أنت في قائمة الانتظار: سنخصص لك حسابًا تلقائيًا ونرسل إليك بريدًا إلكترونيًا فور توفر حساب، حتى لو أغلقت هذه الصفحة.", port_overview: "نظرة عامة", port_balance: "الرصيد", port_profit_loss: "الربح/الخسارة", port_drawdown: "التراجع", port_rank: "الترتيب", port_share: "مشاركة",
    port_trading_obj: "أهداف التداول", port_in_range: "ضمن النطاق",
    port_max_drawdown: "الحد الأقصى للتراجع", port_of_initial: "من الرصيد الابتدائي",
    port_daily_loss: "حد الخسارة اليومي", port_of_starting: "من رصيد بداية اليوم",
    port_monthly_profit: "الحد الأقصى للربح الشهري",
    port_withdrawal_hist: "سجل السحوبات", port_date: "التاريخ", port_payout_amount: "مبلغ الدفع", port_status: "الحالة", port_tx_id: "معرف المعاملة", port_completed: "مكتمل", port_view_all: "عرض جميع السحوبات",
    port_account_details: "تفاصيل الحساب", port_login: "تسجيل الدخول", port_master_pw: "كلمة المرور الرئيسية", port_investor_pw: "كلمة مرور المستثمر", port_mt5_server: "خادم MT5", port_next_payout: "موعد أهلية الدفع القادم", port_request_payout: "طلب دفع",
    port_prop_value: "قيمة PROP", port_current_value: "القيمة الحالية", port_usdc_per_prop: "USDC لكل $PROP", port_30d_change: "تغيير 30 يوم",
    port_help_center: "مركز المساعدة", port_docs: "المستندات", port_discord: "ديسكورد",
    port_show_pw: "إظهار كلمة المرور", port_hide_pw: "إخفاء كلمة المرور",
    port_activate_title: "قم بتفعيل حساب Prop بقيمة 10,000",
    port_one_time_fee: "رسوم لمرة واحدة",
    port_profit_share: "100% حصة من الأرباح",
    port_about_title: "حول PropFunding",
    port_no_consistency: "لا قواعد للاتساق",
    port_no_min_days: "رافعة مالية 1:10 متاحة",
    port_biweekly: "سحوبات كل أسبوعين",
    port_zero_comms: "$0 عمولات وسبريدات خام",
    port_forex_available: "تداول الفوركس الرئيسية والثانوية والذهب",
    port_platform_stats: "إحصائيات المنصة",
    port_total_funded_stat: "إجمالي المتداولين الممولين",
    port_pool_balance_stat: "رصيد المجمع",
    port_total_payouts_stat: "إجمالي مدفوعات USDC",
    port_prop_value_stat_label: "قيمة $PROP",
    port_stat_week: "+23 هذا الأسبوع",
    port_stat_backed: "مدعوم برأس مال حقيقي",
    port_stat_this_week: "هذا الأسبوع",
    port_stat_7d: "+2.41% (7 أيام)",
    port_real_payouts_title: "متداولون حقيقيون ومدفوعات حقيقية",
    port_payout_modal_title: "طلب دفع",
    port_available_withdraw: "متاح للسحب",
    port_prop_amount_label: "المبلغ المراد سحبه بـ $PROP",
    port_prop_min_error: "الحد الأدنى {min} مطلوب",
    port_prop_max_error: "يتجاوز الرصيد المتاح",
    port_prop_min_placeholder: "الحد الأدنى {min}",
    port_payout_min_tooltip: "الحد الأدنى لمبلغ السحب: {min} PRP (2% من حجم حسابك).",
    port_prop_min_note: "مطلوب حد أدنى للسحب 2%",
    port_you_receive: "ستتلقى",
    port_paste_address: "لصق العنوان",
    port_payout_request_label: "طلب الدفع",
    port_payout_rate_label: "السعر",
    port_usdc_redeemed_label: "USDC المسترد",
    port_processing_fee_label: "رسوم المعالجة",
    port_net_payout_label: "صافي الدفع",
    port_confirm_payout_btn: "تأكيد الدفع",
    port_payout_submitted_title: "تم تقديم طلب الدفع",
    port_payout_submitted_subtitle: "سيراجع فريقنا طلبك. تُقدَّم التحديثات عادةً في غضون 24 ساعة.",
    footer_cta_title: "ابدأ التداول مع", footer_cta_highlight: "النموذج الجديد",
    footer_cta_desc: "انضم إلى نظام تحدد فيه الأداء، لا المنصة، النتائج.",
    footer_cta_btn: "احصل على تمويل",
    share_modal_title: "مشاركة المرتبة في لوحة المتصدرين",
    share_position_label: "لوحة المتصدرين\nالمرتبة",
    share_prop_profit: "ربح PRP", share_usdc_payouts: "مدفوعات USDC", share_referral_code: "رمز الإحالة",
    share_default_text: "أنا #{rank} في لوحة المتصدرين لـ PropFunding 🏆",
    share_field_referral: "رمز الإحالة", share_field_text: "خصص نصك",
    share_overlay: "تراكب", share_overlay_none: "بدون تراكب", share_overlay_bull: "تراكب صعودي", share_overlay_bear: "تراكب هبوطي",
    share_save: "حفظ الصورة", share_copy_link: "نسخ الرابط", share_on: "مشاركة على",
    checkout_title: "شراء حساب ممول",
    checkout_payment_method: "طريقة الدفع",
    checkout_card: "بطاقة ائتمان/خصم", checkout_card_soon: "بطاقة ائتمان/خصم (قريبًا)", checkout_crypto: "كريبتو (USDC/USDT)",
    checkout_discount: "رمز الخصم", checkout_apply: "تطبيق",
    checkout_summary: "الملخص", checkout_account: "حساب Prop بقيمة $10K",
    checkout_discount_line: "خصم", checkout_total: "الإجمالي",
 checkout_card_number: "رقم البطاقة", checkout_expiry: "تاريخ الانتهاء", checkout_cvv: "CVV", checkout_complete: "إتمام", checkout_billing: "بيانات الفوترة", checkout_card_whop_text: "ستُدخل بيانات بطاقتك بأمان في الخطوة التالية.", checkout_crypto_whop_text: "ستتم إعادة توجيهك للدفع بعملة USDC أو USDT. اختر الشبكة في صفحة الدفع وأرسل عبر تلك الشبكة فقط.", checkout_confirming: "جارٍ تأكيد دفعتك…", checkout_processing: "يجري معالجة دفعتك. سيتم تفعيل حسابك فور تأكيدها.", checkout_back_portfolio: "العودة إلى المحفظة",
    cs_title: "حالة الدفع", cs_loading: "جارٍ تحميل دفعتك…", cs_not_found: "تعذّر تحميل هذه الدفعة.", cs_awaiting: "بانتظار الدفع", cs_awaiting_desc: "أكمل الدفع في صفحة الدفع. يتم تحديث هذه الصفحة تلقائيًا.", cs_confirming: "جارٍ التأكيد", cs_confirming_desc: "دفعتك على البلوكشين. ننتظر تأكيدها.", cs_partially_paid: "مدفوع جزئيًا", cs_partially_paid_desc: "استلمنا جزءًا من دفعتك. أرسل المبلغ المتبقي من صفحة الدفع.", cs_paid: "مدفوع", cs_paid_activation: "تم استلام الدفعة. تم تفعيل حسابك.", cs_expired: "منتهي الصلاحية", cs_expired_desc: "انتهت صلاحية طلب الدفع هذا. إذا كنت قد أرسلت أموالًا بالفعل، فتواصل مع الدعم. وإلا فابدأ عملية دفع جديدة.", cs_needs_review: "قيد المراجعة", cs_needs_review_desc: "استلمنا دفعتك ويقوم فريقنا بمراجعتها. سنتواصل معك قريبًا.", cs_amount_due: "المبلغ المستحق", cs_paid_so_far: "المدفوع حتى الآن", cs_open_widget: "فتح صفحة الدفع", cs_network_warning: "أرسل USDC أو USDT فقط، وعبر الشبكة التي اخترتها في صفحة الدفع فقط. ستُفقد الإيداعات المرسلة عبر أي شبكة أخرى.",
    checkout_funded_received: "تم استلام الدفعة. نقوم بإعداد حسابك الممول وسيظهر في محفظتك بمجرد أن يصبح جاهزًا.",


    port_tooltip_withdraw: "الحد الأقصى للمبلغ المؤهل للسحب بناءً على صافي ربح حسابك في MT5، بعد خصم رسوم المعالجة المطبقة",
    port_tooltip_max_drawdown: "الحد الأقصى الثابت للخسارة بناءً على رصيدك الابتدائي. إذا وصلت حقوق ملكيتك إلى هذا المستوى، يتم تعطيل الحساب تلقائيًا",
    port_tooltip_daily_loss: "الحد الأقصى لخسارة حقوق الملكية المسموح بها في يوم تداول واحد. يشمل حد الخسارة اليومية كلاً من المراكز المفتوحة والمغلقة",
    port_tooltip_monthly_profit: "الحد الأقصى للربح الذي يمكنك سحبه في شهر تقويمي واحد. يُعاد تعيينه في الأول من كل شهر",
    port_tooltip_balance: "إجمالي رصيد حسابك المحسوم بـ PRP بعد الصفقات المغلقة",
    port_tooltip_profit_loss: "ربحك أو خسارتك المحققة من الصفقات المكتملة",
    port_tooltip_drawdown: "التراجع الحالي لديك بناءً على المراكز الخاسرة النشطة والمغلقة",
    port_tooltip_rank: "ترتيبك بين المتداولين النشطين في PropFunding",
    port_tooltip_prop_value: "تُحوَّل أرباح PRP المؤهلة بهذا السعر الثابت عند السحب",
    // Strings added after the first translation pass
    ref_payout_date: "تاريخ الدفع",
    ref_status: "الحالة",
    ref_tab_all: "الكل",
    ref_tab_claimed: "المُطالب بها",
    ref_status_trial: "تجريبي",
    ref_status_activated: "مُفعّل",
    ref_status_claimed: "تمت المطالبة",
    ref_no_claimed: "لا توجد مكافآت مُطالب بها بعد.",
    ref_no_referrals: "لا توجد إحالات بعد. شارك رابطك لتبدأ الكسب.",
    ref_loading: "جارٍ تحميل إحالاتك…",
    ref_load_error: "تعذّر تحميل إحالاتك.",
    ref_retry: "إعادة المحاولة",
    ref_using_code: "أنت تستخدم الرمز: {code}",
    share_saving: "جارٍ الحفظ…",
    share_loading: "جارٍ تحميل الصورة",
    share_discord_copied: "تم نسخ المنشور. الصقه في Discord.",
    share_failed: "لم ينجح ذلك. يُرجى المحاولة مرة أخرى.",
    help_title: "مركز المساعدة",
    help_subtitle: "احصل على المساعدة بشأن حسابك وتابع طلبات الدعم.",
    help_report_issue: "الإبلاغ عن مشكلة",
    help_report_issue_title: "الإبلاغ عن مشكلة",
    help_search_placeholder: "ابحث في مقالات المساعدة",
    help_support_tickets: "تذاكر الدعم",
    help_tab_open: "مفتوحة",
    help_tab_resolved: "تم حلها",
    help_issue: "المشكلة",
    help_category: "الفئة",
    help_submitted: "تاريخ الإرسال",
    help_status: "الحالة",
    help_action: "الإجراء",
    help_status_in_progress: "قيد المعالجة",
    help_status_resolved: "تم الحل",
    help_see_details: "عرض التفاصيل",
    help_manage: "إدارة",
    help_no_tickets: "لا توجد تذاكر هنا.",
    help_faq: "الأسئلة الشائعة",
    help_articles: "مقالات",
    help_popular_articles: "مقالات شائعة",
    help_no_results: "لا توجد مقالات تطابق بحثك.",
    help_ticket_details: "تفاصيل التذكرة",
    help_ticket_id: "رقم التذكرة",
    help_description: "الوصف",
    help_attachment: "المرفق",
    help_original_message: "الرسالة الأصلية",
    help_additional_detail: "تفاصيل إضافية",
    help_original_attachment: "المرفق الأصلي",
    help_additional_attachment: "مرفق إضافي",
    help_need_more_info: "هل تحتاج إلى إضافة معلومات؟",
    help_add_details_placeholder: "أضف تفاصيل إضافية...",
    help_upload_screenshot: "رفع لقطة شاشة",
    help_add_update: "إضافة تحديث",
    help_status_sent: "مُرسلة",
    help_select_category: "اختر الفئة",
    help_issue_description: "وصف المشكلة",
    help_issue_description_hint: "يُرجى وصف المشكلة بالتفصيل.",
    help_describe_placeholder: "صِف المشكلة التي تواجهها...",
    help_attachment_optional: "مرفق (اختياري)",
    help_attachment_hint: "ارفع لقطة شاشة لمساعدتنا على فهم المشكلة بشكل أسرع.",
    help_upload_or_drag: "ارفع ملفًا أو اسحبه هنا",
    help_cancel: "إلغاء",
    help_submit_issue: "إرسال المشكلة",
    help_issue_reported: "تم الإبلاغ عن المشكلة",
    help_issue_reported_note: "تم الإبلاغ عن مشكلتك بنجاح. تابع قسم مركز المساعدة للاطلاع على التحديثات.",
    help_report_another: "الإبلاغ عن مشكلة أخرى",
    help_done: "تم",
    help_report_category_issue: "الإبلاغ عن مشكلة في {category}",
    help_articles_title: "المقالات",
    help_team_reply: "رد فريق الدعم", help_loading: "جارٍ التحميل…", help_sending: "جارٍ الإرسال…", help_tickets_error: "تعذّر تحميل تذاكرك.", help_try_again: "حاول مرة أخرى",
    port_free_title: "دخول مجاني. هدف واحد.",
    port_free_desc: "حقق +1% على حسابك البالغ 10,000 PRP لتتأهل للتفعيل.",
    port_start_trading: "ابدأ التداول",
    port_getting_ready: "جارٍ تجهيز حسابك...",
    port_free_accounts_stat: "الحسابات المجانية المُفتتحة",
    port_qualified_stat: "المتداولون المؤهلون",
    port_activated_stat: "الحسابات المُفعّلة",
    port_total_paid_stat: "إجمالي USDC المدفوع",
    port_tooltip_free_accounts: "إجمالي عدد الحسابات المجانية بقيمة 10,000 PRP التي افتُتحت على PropFunding",
    port_tooltip_qualified: "المتداولون الذين حققوا هدف التأهل البالغ +1%",
    port_tooltip_activated: "الحسابات المؤهلة التي دفعت رسوم التفعيل وأكملت التحقق KYC",
    port_tooltip_total_paid: "إجمالي USDC المدفوع لمتداولي PropFunding",
    port_inactivity: "عدم النشاط",
    port_tooltip_inactivity: "يجب أن تتداول مرة واحدة على الأقل كل 14 يومًا وإلا سيتم تعطيل حسابك",
    port_qualifying_target: "هدف التأهل",
    port_tooltip_qualifying: "نمِّ حسابك البالغ 10,000 PRP بنسبة 1% لتتأهل للتفعيل",
    port_min_trading_days: "الحد الأدنى لأيام التداول",
    port_tooltip_min_days: "يحتاج حسابك إلى 3 أيام تداول على الأقل للتأهل",
    port_achieved: "تم تحقيقه",
    port_reached: "تم بلوغه",
    port_days: "أيام",
    port_process: "العملية",
    port_how_it: "كيف",
    port_works: "يعمل",
    port_step1_title: "ابدأ مجانًا",
    port_step1_desc: "ابدأ تداول حسابك البالغ 10,000 PRP دون أي رسوم مسبقة.",
    port_step2_title: "حقق +1%",
    port_step2_desc: "نمِّ حسابك بنسبة 1% لتتأهل. يحتاج الحساب إلى 3 أيام تداول على الأقل للتأهل.",
    port_step3_title: "فعِّل وتحقق",
    port_step3_desc: "ادفع رسوم التفعيل خلال 48 ساعة وأكمل التحقق KYC.",
    port_step4_title: "استرد بعملة USDC",
    port_step4_desc: "اسحب ربح التأهل البالغ +1% بعملة USDC عند التفعيل. يُعاد ضبط حسابك وتبدأ عمليات السحب العادية بعد 14 يومًا.",
    port_mt5_account_details: "تفاصيل حساب MT5",
    port_usdc_per_prp: "USDC لكل PRP",
    port_hit_target: "لقد حققت 1%.",
    port_time_to_activate: "حان وقت التفعيل.",
    port_activate_desc: "فعِّل خلال 48 ساعة لفتح حسابك المموَّل وسحب ربح التأهل البالغ 1%.",
    port_activate_soon: "فعِّل قريبًا –",
    port_time_running_out: "الوقت ينفد",
    port_activate_urgent_desc: "أنت معرّض لخسارة حسابك المموَّل. ادفع رسوم التفعيل خلال 24 ساعة لتجنب ذلك.",
    port_window_title: "مهلة التفعيل",
    port_window_expired: "انتهت",
    port_window_expired_desc: "انتهت مهلة التفعيل البالغة 48 ساعة. لم يعد بالإمكان تفعيل هذا التأهل.",
    port_qualification_result: "نتيجة التأهل",
    port_qualification_reached: "تم بلوغ +1%",
    port_qualification_redemption: "استرداد التأهل",
    port_expired_value: "منتهٍ",
    port_activation_status: "حالة التفعيل",
    port_expired_status: "منتهٍ",
    port_expired_on: "انتهى في {date} الساعة {time}",
    port_start_next_attempt: "ابدأ المحاولة المجانية التالية",
    port_activation_fee: "رسوم التفعيل",
    port_redeem_after_activation: "الاسترداد المتاح بعد التفعيل",
    port_redeem_after_activation_short: "الاسترداد بعد التفعيل",
    port_time_left: "الوقت المتبقي للتفعيل",
    port_hours: "ساعات",
    port_minutes: "دقائق",
    port_seconds: "ثوانٍ",
    port_activate_short: "فعِّل",
    checkout_claim_title: "ادفع للحصول على حسابك المموَّل",
    checkout_card_with_fee: "بطاقة ائتمان/خصم (رسوم معالجة 2.9%)",
    checkout_card_with_fee_short: "بطاقة ائتمان/خصم (رسوم 2.9%)",
    checkout_activation_account: "حساب Prop بقيمة 10K$",
    checkout_card_fee: "رسوم معالجة البطاقة",
    checkout_crypto_plain: "عملات رقمية",
    port_next_steps: "الخطوات التالية",
    port_pending: "قيد الانتظار",
    port_next_verify_title: "تحقق من هويتك",
    port_next_verify_desc: "تحقق KYC سريع لفتح المدفوعات.",
    port_next_withdraw_title: "اسحب 1% الخاصة بك",
    port_next_withdraw_desc: "مكافأتك على بلوغ هدف التأهل.",
    port_next_trade_title: "واصل التداول",
    port_next_trade_desc: "اسعَ نحو الإنجاز التالي في السوق.",
    port_kyc_title: "التحقق KYC",
    port_kyc_required: "المستندات المطلوبة",
    port_kyc_doc_id: "إثبات الهوية (جواز سفر، رخصة قيادة، بطاقة هوية حكومية).",
    port_kyc_doc_address: "إثبات العنوان (فاتورة خدمات، فاتورة هاتف، كشف حساب بنكي).",
    port_kyc_start: "ابدأ التحقق من الهوية",
    port_kyc_error: "خطأ في التحقق",
    port_kyc_error_desc: "تعذّر علينا التحقق من هويتك.",
    port_kyc_try_again: "إعادة المحاولة",
    port_kyc_contact_support: "تواصل مع الدعم",
    port_kyc_pending: "قيد المراجعة",
    port_kyc_pending_desc: "نراجع مستنداتك حاليًا. يستغرق ذلك عادةً بضع دقائق، وسنحدّث هذه البطاقة عند الانتهاء.",
    port_kyc_rejected_desc: "تعذّر علينا التحقق من هويتك ولا يمكن إعادة هذا التحقق. يُرجى التواصل مع الدعم.",
    port_kyc_loading: "جارٍ بدء التحقق...",
    port_withdraw_profit: "سحب الربح",
    port_to_withdraw: "للسحب",
    port_tooltip_to_withdraw: "ربح التأهل البالغ +1%، قابل للاسترداد بعملة USDC",
    port_max_withdraw_note: "الحد الأقصى المسموح للسحب 1%",
    port_rule_title_max_drawdown: "الحد الأقصى للتراجع",
    port_rule_title_daily_loss: "الخسارة اليومية",
    port_rule_title_inactivity: "قاعدة عدم النشاط",
    port_rule_name_max_drawdown: "الحد الأقصى للتراجع",
    port_rule_name_daily_loss: "حد الخسارة اليومية",
    port_rule_name_inactivity: "قاعدة عدم النشاط",
    port_and: "و",
    port_breach_desc_prefix: "تجاوز حسابك",
    port_breach_desc_inactivity: "خالف حسابك قاعدة عدم النشاط.",
    port_breach_retry_left: "تبقّت لديك محاولة مجانية أخرى.",
    port_free_retry: "محاولة مجانية",
    port_prp_value: "قيمة PRP",
    port_breached: "تم تجاوزه",
    port_exhausted_title: "انتهت محاولاتك المجانية",
    port_exhausted_desc: "لقد استنفدت محاولاتك المجانية.",
    port_exhausted_offer: "لا يزال بإمكانك تفعيل حساب مموَّل فورًا مقابل",
    port_promo_prefix: "استخدم الرمز",
    port_promo_suffix: "للحصول على خصم 10%.",
    port_offer_title: "🎉 عرض التفعيل الأول",
    port_offer_desc: "استخدم {code} عند الدفع للحصول على خصم 10% على تفعيلك الأول.",
    port_offer_copy: "نسخ الرمز",
    port_offer_copied: "تم النسخ",
    port_offer_remaining: "متبقٍ {left} من {total} مستخدم",
    port_get_funded_for: "احصل على التمويل مقابل",
    port_get_funded: "احصل على التمويل",
    port_cycle_ended_title: "انتهت دورة التداول",
    port_cycle_ended_desc: "تجاوز حسابك حدّي الحد الأقصى للتراجع والخسارة اليومية.",
    port_promo_new_account: "للحصول على خصم 10% على حسابك الجديد.",
    port_get_funded_again: "احصل على التمويل مجددًا",
    port_previous_cycle: "الدورة السابقة",
    port_drawdown_reached: "التراجع المبلوغ",
    port_daily_loss_reached: "الخسارة اليومية المبلوغة",
    port_final_equity: "حقوق الملكية النهائية",
    port_what_we_offer: "ما نقدمه",
    port_offer_free_title: "ابدأ مجانًا",
    port_offer_free_desc: "ادفع فقط بعد أن تحقق +1%.",
    port_offer_loss_title: "حد خسارة أقصى ثابت 20%",
    port_offer_loss_desc: "مساحة أكبر للتداول.",
    port_offer_share_title: "مشاركة أرباح 100%",
    port_offer_share_desc: "1 PRP = 0.50 USDC.",
    port_previous_payouts: "المدفوعات السابقة",
    port_view_all_payouts: "عرض كل المدفوعات",
    port_help_intro: "فريقنا هنا إذا احتجت إلى أي شيء.",
    port_redemption_note: "من {prp} PRP بسعر استرداد {rate} USDC",
    port_erc20_label: "عنوان USDC ERC20",
    port_payout_review_note: "يُرجى الانتظار 24 ساعة للمراجعة. بعد الموافقة، ستتم مزامنة حساب MT5 الجديد الخاص بك.",
    acc_full_name: "الاسم الكامل",
    acc_email: "البريد الإلكتروني",
    acc_save: "حفظ",
    acc_saving: "جارٍ الحفظ…",
    acc_saved: "تم الحفظ.",
    port_mt5_download: "تنزيل MT5",
    menu_dark_mode: "الوضع الداكن",
    menu_join_discord: "انضم إلى مجتمع Discord",
    menu_logout: "تسجيل الخروج",
  },
};

export default translations;
